<section>
  <img *ngIf="themeService.active.name != 'defaultTheme' && myFormTemplate.aboutMe==true" class="sign-in-background"
    src="../../../assets/img/{{themeService.theme}}/zp-lg-background.png" alt="">

  <header class="background-header">
    <img src="../../assets/img/{{themeService.theme}}/header-background.svg" alt="" class="background-header-img"
      [ngClass]="{backgroundWidth: themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}">
    <section *ngIf="myFormTemplate && myFormTemplate.aboutMe == true" class="navbar-brand navbar-brand-choose-plan">
      <img class="main-logo main-img-about-me" src="../../assets/img/{{themeService.theme}}/main-logo.png"
        alt="Company Logo" width="125px">
    </section>
  </header>
  <header class="mobile-header" *ngIf="myFormTemplate && myFormTemplate.aboutMe == true">
    <img src="../../assets/img/{{themeService.theme}}/main-logo.png" alt="Company Logo" width="150px">
  </header>
  <section class="main-side-nav" *ngIf="dataIsLoaded && myFormTemplate" [ngClass]="{'main-side-nav-about-me':myFormTemplate.aboutMe==true,
                'main-side-nav-about-me-blue-theme': themeService.active.name != 'defaultTheme' && myFormTemplate.aboutMe==true,
                'main-side-nav-delegate-form': myFormTemplate && myFormTemplate.sectionTitle == 'delegates' && myFormTemplate.subject == 'Tell us about your delegate',
                'main-side-nav-edit-delegate':myFormTemplate && myFormTemplate.sectionTitle == 'delegates' && myFormTemplate.subject == 'Edit',
	             hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true}">
    <section class="container dynamic-form-data-entry-container dynamic-collapse-top"
      id="dynamicFormDataEntryContainer">
      <section class="dynamic-collapse" [ngClass]="{'dynamic-collapse-theme-bar-nav': themeService.theme != 'default' && themeService.theme != 'bluecoat', 'dynamic-collapse-bluecoat-bar-nav': themeService.theme == 'bluecoat'}">
        <section class="dynamic-collapse-header" data-bs-toggle="collapse" data-bs-target="#example1">
          <h1 class="col" *ngIf="myFormTemplate.subject !== 'Review'">{{myFormTemplate.subject}} {{itemName}}</h1>
          <h1 class="col" *ngIf="myFormTemplate.subject === 'Review'">{{myFormTemplate.subject}} {{itemName}}'s
            permissions</h1>
          <!-- <h1 class="col" *ngIf="myUser.professionalIsDelegate==true">Review {{itemName}}'s permissions</h1> -->
        </section>
        <section class="dynamic-collapse-main">
          <section class="dynamic-collapse-content"
            [ngClass]="{'dynamic-collapse-content-edit-delegate': myFormTemplate && myFormTemplate.sectionTitle == 'delegates' && myFormTemplate.subject == 'Edit', 'dynamic-collapse-content-ownership': selectedOwner}">
            <form [formGroup]="myFormGroup" (ngSubmit)="onSubmit()" class="dynamic-data-entry-form">
              <section class="container dynamic-form-data-entry-flex-container">
                <section *ngFor="let form_elem of myFormTemplate.fields; let i = index" [ngClass]="{
                                            'dynamic-data-flex':myFormTemplate.sectionTitle!='general expenses',
                                            'dynamic-data-flex-general-expense-intro': myFormTemplate.currentUrl == 'general-expense-intro',
											'dynamic-data-flex-general-expense':myFormTemplate.sectionTitle=='general expenses' && myFormTemplate.subject == 'Edit',
											'dynamic-data-flex-25-frequency':myFormTemplate.sectionTitle=='general expenses' && form_elem.dataFlex25Frequency == true && !isDE,
											'dynamic-data-flex-25-memo':myFormTemplate.sectionTitle=='general expenses' && form_elem.dataFlex25Memo == true && !isDE,
											'dynamic-data-flex-50':myFormTemplate.sectionTitle=='general expenses' && form_elem.dataFlex50 == true && !isDE,
											'dynamicFlexJointOwnersList':form_elem.inputtype == 'jointOwnersList',
											'dynamic-data-flex-all': form_elem.dataFlexAll == 'true',
											'dynamic-data-flex-warning': form_elem.inputtype == 'warning',
											'delegate-intro-100': form_elem.delegateIntro == 'true',
											'delegate-intro': form_elem.inputtype == 'delegatesIntroduction',
                      'align-to-middle': form_elem.alignToMiddle == true,
											'dynamic-data-flex-100': form_elem.dataFlex100 == 'true' || form_elem.fieldid == 'upload' || form_elem.fieldid == 'personToNotifyForDigitalLegacy' || form_elem.fieldid == 'personToNotifyForDigitalLegacy',
                      'videoTuTorialStyle': form_elem.videoTuTorialStyle == true,
                      'inverseMarginTop': form_elem.inverseMarginTop == true,
                      'dynamic-data-flex-10perc': form_elem.fieldid === 'executor',
                      'dynamic-data-margin-dropdown': form_elem.inputtype == 'conditionaldropdown' || form_elem.inputtype == 'dropdowncountries',
                                            'mailDelegateToRemove': myFormTemplate.editMode == true && myFormTemplate.sectionTitle == 'delegates' && form_elem.fieldid == 'email',
											'dynamic-special-toggle': form_elem.fieldid == 'attorneysPower_Ordinary' ||
																		form_elem.fieldid == 'attorneysPower_LastingHealth' ||
																		form_elem.fieldid == 'attorneysPower_LastingProperty' ||
																		form_elem.fieldid == 'attorneysPower_Enduring'
											}">
                  <section [ngSwitch]="form_elem.inputtype" class="input-types">
                    <section *ngSwitchCase="'itemIntroAbout'" class="item-intro">
                      <div class="dynamic-item">
                        <h2 class="intro-item-title">About {{form_elem.item}}</h2>
                        <p class="intro-item-para">{{form_elem.info}}</p>
                        <p *ngIf="form_elem.infoScdLine" class="intro-item-para-scd-line">
                          {{form_elem.infoScdLine}}</p>
                      </div>
                    </section>

                    <section *ngSwitchCase="'beforeGettingStarted'" class="before-getting-started">
                      <div class="dynamic-item">
                        <div class="title-section">
                          <h2 class="intro-item-title">Before getting started</h2>
                          <img src="../../assets/img/{{themeService.theme}}/how-works.svg" width="90px" alt="">
                        </div>
                        <p class="intro-item-para">{{form_elem.info}}</p>
                        <ul *ngIf="form_elem.list">
                          <li *ngFor="let item of form_elem.list">{{item.itemlist}}</li>
                        </ul>
                      </div>
                    </section>

                    <section *ngSwitchCase="'generalExpenses_intro'" class="general-expenses-intro">
                      <h2 *ngIf="form_elem.categoryType == 'houseHoldPersonal'" class="intro-item-title">Household &
                        Personal</h2>
                      <h2 *ngIf="form_elem.categoryType == 'familyPet'" class="intro-item-title">
                        Family & Pets</h2>
                      <h2 *ngIf="form_elem.categoryType == 'leisure'" class="intro-item-title">
                        Leisure
                      </h2>
                      <h2 *ngIf="form_elem.categoryType == 'map'" class="intro-item-title">
                        Transport
                      </h2>
                      <p>Enter the amount you spend on each expense and how often. You can skip
                        any
                        that don't apply to you.</p>
                    </section>

                    <section *ngSwitchCase="'beforeGettingStarted'" class="before-getting-started-mobile">
                      <div class="dynamic-item">
                        <div class="title-section" (click)="statusGetetingStarted = !statusGetetingStarted">
                          <header>
                            <img src="../../assets/img/{{themeService.theme}}/how-works.svg" width="60px" alt="">
                            <h2 class="intro-item-title">Before getting started</h2>
                          </header>
                          <section [ngClass]="{arrowDown: statusGetetingStarted}">
                            <img src="../../assets/img/{{themeService.theme}}//top-arrow.svg" alt="">
                          </section>
                        </div>
                        <div class="hide-part" [ngClass]="{showHidePartGettingStarted: statusGetetingStarted}">
                          <p class="intro-item-para">{{form_elem.info}}</p>
                          <ul *ngIf="form_elem.list">
                            <li *ngFor="let item of form_elem.list">{{item.itemlist}}</li>
                          </ul>
                        </div>
                      </div>
                    </section>

                    <section *ngSwitchCase="'infoBox'">

                    </section>

                    <section *ngSwitchCase="'personToNotifyForDigitalLegacy'">
                      <app-dynamic-person-to-notify *ngIf="!isDE" [formGroup]="myFormGroup" [title]="form_elem.title"
                        [label]="form_elem.label" formControlName="{{form_elem.fieldid}}" [id]="form_elem.fieldid"
                        (personData)="handlePersonData($event)" [typeOfLegacy]="form_elem.typeOfLegacy">
                      </app-dynamic-person-to-notify>

                      <div *ngIf="isDE">
                        <div class="dynamic-item">
                          <div class="form-group">
                            <section class="person-to-notify-container">
                              <div class="title-section">
                                <div class="title">Legacy Contacts</div>
                                <img src="../../assets/img/default/help-btn.svg" alt="" width="35" ngbTooltip="">
                              </div>
                              <!-- <div class="subtitle">Who have you add to be notified when your account is inactive?</div> -->
                              <ng-container *ngFor="let person of personToNotifyList; let i = index">
                                <div class="person-to-notify">
                                  <div class="label-name">
                                    <div class="special-ovale ovale-name">Name</div>
                                    <input type="text" #nameInput [value]="person.name"
                                      (input)="onPersonChange(i, 'name', nameInput.value)" placeholder="Name">
                                  </div>
                                  <div class="label-email">
                                    <div class="special-ovale ovale-email">Email</div>
                                    <input type="email" #emailInput [value]="person.email"
                                      (input)="onPersonChange(i, 'email', emailInput.value)" placeholder="Email">
                                  </div>
                                  <div class="label-data-shared">
                                    <ng-container *ngIf="itemName == 'Google'">
                                      <div class="special-ovale ovale-select">Data Shared</div>
                                      <select #dataSharedSelect [value]="person.dataShared"
                                        (change)="onPersonChange(i, 'dataShared', dataSharedSelect.value)">
                                        <option value="All">All</option>
                                        <option value="Some">Some</option>
                                        <option value="None">None</option>
                                      </select>
                                    </ng-container>
                                    <ng-container *ngIf="itemName == 'Facebook'">
                                      <div class="special-ovale ovale-select">Data archive access</div>
                                      <select #dataSharedSelect [value]="person.dataShared"
                                        (change)="onPersonChange(i, 'dataShared', dataSharedSelect.value)">
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                      </select>
                                    </ng-container>
                                    <ng-container *ngIf="itemName == 'Apple'">
                                      <div class="special-ovale ovale-select">Access key shared</div>
                                      <select #dataSharedSelect [value]="person.dataShared"
                                        (change)="onPersonChange(i, 'dataShared', dataSharedSelect.value)">
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                      </select>
                                    </ng-container>
                                  </div>
                                  <button class="btn primary-sml-btn remove-person"
                                    (click)="$event.preventDefault(); removePerson(i)">Remove</button>
                                </div>


                              </ng-container>
                              <ng-container *ngIf="form_elem.typeOfLegacy!='Facebook'">
                                <div class="add-save-btns">
                                  <button class="btn primary-sml-btn add-another-person"
                                    (click)="$event.preventDefault(); addPerson()">Add a person
                                  </button>
                                </div>
                              </ng-container>
                            </section>
                          </div>
                        </div>
                      </div>


                    </section>


                    <section *ngSwitchCase="'videoTutorial'">
                      <div class="dynamic-item">
                        <ng-container *ngIf="form_elem.googleVideo==true">
                          <video width="800" height="450" autoplay loop muted controls>
                            <source src="../../assets/video/Google Inactive Account Manager - Explainer Video.mp4"
                              type="video/mp4">
                          </video>
                        </ng-container>

                        <ng-container *ngIf="form_elem.appleVideo==true">
                          <video width="800" height="450" autoplay loop muted controls>
                            <source src="../../assets/video/Apple legacy contact.mp4" type="video/mp4">
                          </video>
                        </ng-container>

                        <ng-container *ngIf="form_elem.facebookVideo==true">
                          <video width="800" height="450" autoplay loop muted controls>
                            <source src="../../assets/video/Facebook Memorialisation.mp4" type="video/mp4">
                          </video>
                        </ng-container>
                      </div>
                    </section>

                    <section *ngSwitchCase="'formPresentation'" class="form-presentation">
                      <div class="dynamic-item">
                        <div class="dynamic-group">
                          <div class="title-section">{{form_elem.presentationTitle}}</div>
                          <div *ngIf="form_elem.explanation.length>0" class="dynamic-info-btn-freetext info-mark-de"
                            ngbTooltip="{{form_elem.explanation}}" placement="{{form_elem.tooltipPlacement}}">
                            <!-- <img src="../../assets/img/info-btn.svg" height="35px" alt=""> -->
                            <div class="svg-container help-btn-svg-container">
                              <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 832.46 905" width="30px">

                                <path
                                  d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                  transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                                <path
                                  d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                  transform="translate(-95.77 -59.5)" fill="#fff" />
                                <path
                                  d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                                <path
                                  d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                              </svg>
                            </div>
                          </div>

                          <!-- Tooltip on mobile -->
                          <div *ngIf="statusTooltipMobile[i] && form_elem.explanation.length>0"
                            class="container-tooltip-show-mobile">
                            <div class="tooltip-show-mobile">{{form_elem.explanation}}</div>
                          </div>
                          <div class="info-mark-mobile" *ngIf="questionMarkMobile && form_elem.explanation.length>0"
                            (click)="statusTooltipMobile[i] = !statusTooltipMobile[i]">
                            <!-- <img src="../../assets/img/info-btn.svg" height="35px" alt="section logo"> -->
                            <div class="svg-container help-btn-svg-container">
                              <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 832.46 905" width="30px">

                                <path
                                  d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                  transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                                <path
                                  d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                  transform="translate(-95.77 -59.5)" fill="#fff" />
                                <path
                                  d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                                <path
                                  d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                              </svg>
                            </div>
                          </div>
                        </div>
                        <div class="form-group">
                          <div>{{form_elem.presentationContent}}</div>
                          <div>{{form_elem.presentationOtherContent}}</div>
                        </div>
                      </div>
                    </section>

                    <section *ngSwitchCase="'formIntroduction'" class="form-introduction form-presentation">
                      <div class="dynamic-item">
                        <div class="title-section form-introduction-title">
                          <span>{{form_elem.introduction}}</span>
                          <img src="../../assets/img/{{themeService.theme}}/how-works.svg" alt="" height="40px">
                        </div>
                        <div class="form-group">
                          <p *ngIf="form_elem.formIntroInfoFirstPara">
                            <span *ngIf="form_elem.facebookExplanations==true"><strong>Memorialise</strong><br></span>
                            {{form_elem.formIntroInfoFirstPara}}
                          </p>
                          <p *ngIf="form_elem.formIntroInfoScdPara">
                            <span *ngIf="form_elem.facebookExplanations==true"><strong>Delete</strong><br></span>
                            {{form_elem.formIntroInfoScdPara}}
                          </p>
                          <p *ngIf="form_elem.formIntroInfoThirdPara">{{form_elem.formIntroInfoThirdPara}}</p>
                        </div>
                      </div>
                    </section>

                    <section *ngSwitchCase="'proTips'" class="form-presentation pro-tips-container">
                      <div class="dynamic-item">
                        <div class="title-section">
                          <div class="title-row">
                            <span>{{form_elem.title}}</span>
                            <img src="../../assets/img/{{themeService.theme}}/how-works.svg" alt="" height="40px">
                          </div>
                        </div>
                        <div class="content">
                          <div class="tip" *ngIf="form_elem.firstTip">{{form_elem.firstTip}}</div>
                          <div class="tip scd-tip" *ngIf="form_elem.secondTip">{{form_elem.secondTip}}</div>
                        </div>
                      </div>
                    </section>

                    <!-- <section *ngSwitchCase="'recordButton'" class="recordButton">
                      <button class="btn primary-lg-btn">Record Settings</button>
                    </section> -->



                    <!-- Joint Owners List Selection -->
                    <section *ngSwitchCase="'jointOwnersList'" class="jointOwnersList-container">
                      <div class="dynamic-item joint-owners joint-owners-list">
                        <div class="title-section">Select Owner(s)</div>
                        <div class="form-group">
                          <label class="joint-owner-label">{{form_elem.label}}</label>

                          <main class="main-section owners-list" *ngIf="myUser">
                            <div *ngFor="let owner of selectedOwners; let i = index">
                              <label class="check-label" [for]="'jointOwner'+i">
                                <span>{{owner.first}} {{owner.last}}</span>
                                <input type="checkbox" [id]="'jointOwner'+i" [name]="owner" class="form-check-input"
                                  (change)="getCheckboxValues($event,owner, form_elem.fieldid)"
                                  [ngClass]="selectedOwner ? 'checked' : 'unchecked'"
                                  [checked]="selectedOwnersList[owner.first + owner.last]">
                                <span class="checkmark"></span>
                              </label>
                            </div>
                            <div class="create-owner" *ngIf="!myUser.sharedPlanUserId">
                              <button (click)="createNewOwner()">Create New Owner</button>
                              <div class="svg-container help-btn-svg-container"
                                ngbTooltip="Use this button to add a new item owner to your plan. You can then return and list them as an owner for this item."
                                placement="right">
                                <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="30px"
                                  viewBox="0 0 832.46 905">
                                  <path
                                    d="M821.24,842.05c-44.62,44.62-84.61,78-137.16,98.8-19.58,7.77-49.17,13.79-69.47,18-122.82,25.39-256.92-6-379.44-128.5C92.46,687.62,88.24,383,243.16,235.21,420.63,65.87,665.57,92.86,821.24,248.53,983.08,410.37,983.08,680.21,821.24,842.05Z"
                                    transform="translate(-110.16 -62)" opacity="0.3" />
                                  <path
                                    d="M794.26,774.53c-44,44-83.44,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73-140.74-140.73-144.9-441.1,7.89-586.89,175-167,416.57-140.38,570.08,13.14C953.86,348.82,953.86,614.93,794.26,774.53Z"
                                    transform="translate(-110.16 -62)" class="svg-background" />
                                  <g>
                                    <path
                                      d="M617.21,321.54c-12.72-21.24-39.49-47.33-94.76-51.09-60.22-4.11-106.7,26-130.89,84.73-2.86,6.94-1.31,14.32,4.36,20.78,9.39,10.7,29.86,18.15,38.28,15.91,9-2.41,13.66-10.09,18.56-18.21,5.4-9,12.11-20.11,27.08-29.81,16.56-10.75,36.57-8.07,47-5.52,18.75,4.58,31.32,13.94,34.26,19.12,6.75,11.89,9.8,44.62-26.93,83.39-29.61,31.28-44.63,65.83-44.63,102.71v34.87c0,6.94,4.1,12.62,11.26,15.58,4.57,1.9,10.82,2.68,17.38,2.68,13.7,0,28.77-3.43,32.68-7.34.16-.16.28-.25.37-.33,4.08-3.34,3.66-7.08,3.32-10.09-.39-3.45-1.41-12.61-1.41-37.17,0-25.35,15.47-43.86,33.39-65.3,12.51-15,25.46-30.47,34.17-49.82C636.46,391.68,635.11,351.41,617.21,321.54Z"
                                      transform="translate(-110.16 -62)" class="svg-sign" />
                                    <path
                                      d="M531.23,622.46c-16.81-2.08-32.75,5.89-39.67,19.83-6.83,13.77-6.67,28.4.45,40.14a35,35,0,0,0,29.3,17.08h1.49c9.78,0,26.12-2,36.06-14.09,4.76-5.78,9.67-16.18,6-32.94C561.33,636.1,548.43,624.59,531.23,622.46Z"
                                      transform="translate(-110.16 -62)" class="svg-sign" />
                                  </g>
                                </svg>
                              </div>
                            </div>
                          </main>
                        </div>
                      </div>

                      <ng-container *ngIf="!isOwnerListEmpty">
                        <app-dynamic-joint-ownership [ownersList]="ownersList" [myUser]="myUser"
                          [invalid]="submitted && myFormGroup.get(form_elem.fieldid).errors"
                          [fieldId]="form_elem.fieldid" (newOwnershipObjectToEmit)="addOwnershipFormValue($event)"
                          [errorMessage]="errorMessage">
                        </app-dynamic-joint-ownership>

                        <div class="floating-label">
                          <label class="label" for="{{form_elem.fieldid}}">
                            <input class="form-control floating-input" placeholder=" " type="hidden"
                              formControlName="{{form_elem.fieldid}}"
                              [ngClass]="{'is-invalid' :submitted && myFormGroup.get(form_elem.fieldid).errors}" />
                          </label>
                        </div>

                        <div *ngIf="submitted && myFormGroup.get(form_elem.fieldid).errors" class="invalid-feedback">
                          <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.required">
                            This is a required field.
                          </div>
                        </div>
                      </ng-container>
                    </section>

                    <section *ngSwitchCase="'jointOwnersListExplanations'" class="joint-owners-list-scd-intro">
                      <div class="explanations-btn" (click)="toggleExplanations($event)">
                        <span>{{form_elem.text}}</span>
                        <img src="../../assets/img/{{themeService.theme}}/how-works.svg" alt="" height="40px">
                      </div>
                    </section>

                    <section *ngSwitchCase="'delegateReview'" class="relegate-review-dynamic">
                      <div class="dynamic-item" *ngIf="form_elem.label == 'Select permission'">
                        <div class="dynamic-form-data-entry-input">
                          <div class="label-delegate-review">{{form_elem.permission}}</div>
                          <span class="required-field">{{form_elem.required}}</span>
                          <span class="optional-field">{{form_elem.optional}}</span>
                          <select class="form-control" formControlName="{{form_elem.fieldid}}"
                            [ngClass]="{'is-invalid' :submitted && myFormGroup.get(form_elem.fieldid).errors}">
                            <option *ngFor="let opt of form_elem.items" value="{{opt}}">
                              {{opt}}
                            </option>
                          </select>
                        </div>
                      </div>
                    </section>

                    <section *ngSwitchCase="'explanations'">
                      <div class="dynamic-item">
                        <div class="delegate-explanations-box">
                          <div class="delegate-explanations-container form-group">
                            <div class="next-delegate-explanations-btn" onclick="plusSlides(1)">
                              <img src="../../assets/img/{{themeService.theme}}/top-arrow.svg" class="next-btn"
                                alt="Next button" width="50px">
                            </div>
                            <div class="prev-delegate-explanations-btn" onclick="plusSlides(-1)">
                              <img src="../../assets/img/{{themeService.theme}}/top-arrow.svg" class="prev-btn"
                                alt="Prev button" width="50px">
                            </div>
                            <div class="explanation-container explanation-introduction mySlides">
                              <label for="{{form_elem.fieldid}}">{{form_elem.introLabel}}</label>
                              <div class="delegate-introduction">Introduction</div>
                              <div class="form-group">
                                <div class="explanation">
                                  <div class="first-part">Choose from one of four access
                                    permissions to set your delegate
                                    for each section of your plan.
                                  </div>
                                  <div class="scd-part">You can edit or remove a
                                    delegate's
                                    access at any time, which means
                                    you’re in complete control over exactly how and when
                                    they can access your plan.
                                  </div>
                                </div>
                                <img src="../../assets/img/{{themeService.theme}}/delegate.svg" alt="" width="80px">
                              </div>
                            </div>
                            <div class="explanation-container explanation-contributor mySlides hide-category">
                              <label for="{{form_elem.fieldid}}">{{form_elem.introLabel}}</label>
                              <div class="delegate-introduction">Contributor</div>
                              <div class="form-group">
                                <div class="explanation">
                                  <div class="first-part">This is the broadest permission
                                    level as it allows delegates to
                                    add or edit items.
                                  </div>
                                  <div class="scd-part">You might wish to give a family
                                    member
                                    or trusted professional
                                    Contributor level permission to help you to build
                                    and
                                    manage your plan.
                                  </div>
                                </div>
                                <img src="../../assets/img/{{themeService.theme}}/contributor.svg" alt="" width="80px">
                              </div>
                            </div>
                            <div class="explanation-container explanation-debts mySlides hide-category">
                              <label for="{{form_elem.fieldid}}">{{form_elem.introLabel}}</label>
                              <div class="delegate-introduction">Viewer: Now</div>
                              <div class="form-group">
                                <div class="explanation">
                                  <div class="first-part">Delegates with this permission
                                    level
                                    can access a read-only
                                    version of your plan.
                                  </div>
                                  <div class="scd-part">This is great for sharing
                                    information
                                    with delegate that you wish to
                                    view a section of your plan, but to not have access
                                    to
                                    independently make changes to it.
                                  </div>
                                </div>
                                <img src="../../assets/img/{{themeService.theme}}/viewer-now.svg" alt="" width="80px">
                              </div>
                            </div>
                            <div class="explanation-container explanation-dailyLife mySlides hide-category">
                              <label for="{{form_elem.fieldid}}">{{form_elem.introLabel}}</label>
                              <div class="delegate-introduction">Viewer: Future</div>
                              <div class="form-group">
                                <div class="explanation">
                                  <div class="first-part">Delegates with this level of
                                    access
                                    will not be able to see
                                    sections of your plan until either you pass or lose
                                    mental capacity.
                                  </div>
                                  <div class="scd-part">
                                    Should either event occur, your delegate will
                                    request
                                    access from us and provide
                                    evidence to support their request. <br>
                                  </div>
                                  <div class="third-part">This means you can protect your
                                    privacy today, while making sure
                                    your important information is accessible to those
                                    you
                                    trust when they need it.
                                  </div>
                                </div>
                                <img class="future-img" src="../../assets/img/{{themeService.theme}}/viewer-future.svg"
                                  alt="" width="130px">
                              </div>
                            </div>
                            <div class="explanation-container explanation-wishes mySlides hide-category">
                              <label for="{{form_elem.fieldid}}">{{form_elem.introLabel}}</label>
                              <div class="delegate-introduction">Never</div>
                              <div class="form-group">
                                <div class="explanation">
                                  <div class="first-part">To allocate a No Access
                                    permission
                                    level to a delegate keeps your
                                    plan permanently hidden from them.
                                  </div>
                                  <div class="scd-part">This means that your delegate
                                    cannot
                                    view this section of your plan,
                                    even in the event of your passing or incapacitation.
                                  </div>
                                </div>
                                <img src="../../assets/img/{{themeService.theme}}/no-access.svg" alt="" width="80px">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>

                    <section *ngSwitchCase="'explanationsLink'">
                      <div class="explanations-link" (click)="statusExplanationsLink = !statusExplanationsLink">Learn
                        about delegate permissions</div>
                    </section>

                    <section *ngSwitchCase="'delegatesIntroduction'" class="delegates-intro">
                      <div class="dynamic-item form-group delegates-intro-container">
                        <header class="delegates-intro-header">
                          <h5>What is a delegate?</h5>
                          <img src="../../assets/img/{{themeService.theme}}/delegate.svg" alt="" width="80px">
                        </header>
                        <p>They are the people that you trust most in life – family, close
                          friends
                          or professional
                          advisors – that would benefit from having access to your plan,
                          either
                          today or one day in the
                          future.</p>
                        <p>You can share what you wish, when you wish by setting different
                          levels of
                          access for each
                          delegate. This means you're in complete control, at all times, over
                          exactly who can view or edit
                          your plan and when they can do so.</p>
                      </div>
                    </section>

                    <section *ngSwitchCase="'warning'" class="warning-dynamic banner">
                      <i class="info-fa fa fas fa-info"></i>
                      <div>{{form_elem.text}}</div>
                    </section>



                    <section *ngSwitchCase="'freetext'" class="freetext"
                      [ngClass]="{data50percents: form_elem.delegateIntro == 'true'}">
                      <div class="dynamic-item form-group">
                        <div *ngIf="form_elem.explanation.length>0" class="dynamic-info-btn-freetext info-mark-de"
                          ngbTooltip="{{form_elem.explanation}}" placement="{{form_elem.tooltipPlacement}}">
                          <!-- <img src="../../assets/img/info-btn.svg" height="35px" alt=""> -->
                          <div class="svg-container help-btn-svg-container">
                            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 832.46 905" width="30px">

                              <path
                                d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                              <path
                                d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                transform="translate(-95.77 -59.5)" fill="#fff" />
                              <path
                                d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                transform="translate(-95.77 -59.5)" class="svg-sign" />
                              <path
                                d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                transform="translate(-95.77 -59.5)" class="svg-sign" />
                            </svg>
                          </div>
                        </div>

                        <!-- Tooltip on mobile -->
                        <div *ngIf="statusTooltipMobile[i] && form_elem.explanation.length>0"
                          class="container-tooltip-show-mobile">
                          <div class="tooltip-show-mobile">{{form_elem.explanation}}</div>
                        </div>
                        <div class="info-mark-mobile" *ngIf="questionMarkMobile && form_elem.explanation.length>0"
                          (click)="statusTooltipMobile[i] = !statusTooltipMobile[i]">
                          <!-- <img src="../../assets/img/info-btn.svg" height="35px" alt="section logo"> -->
                          <div class="svg-container help-btn-svg-container">
                            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 832.46 905" width="30px">

                              <path
                                d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                              <path
                                d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                transform="translate(-95.77 -59.5)" fill="#fff" />
                              <path
                                d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                transform="translate(-95.77 -59.5)" class="svg-sign" />
                              <path
                                d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                transform="translate(-95.77 -59.5)" class="svg-sign" />
                            </svg>
                          </div>
                        </div>

                        <div class="dynamic-form-data-entry-input floating-form"
                          [ngClass]="{blankSpace: form_elem.fieldid == 'blankSpace'}">
                          <span class="required-field">{{form_elem.required}}</span>
                          <span class="optional-field">{{form_elem.optional}}</span>
                          <div class="floating-label">
                            <label class="label" for="{{form_elem.fieldid}}">
                              <input type="text" class="form-control floating-input" required="false"
                                formControlName="{{form_elem.fieldid}}"
                                (focusout)="form_elem.mustMatch ? MatchConfirmed($event,form_elem.mustMatch):null"
                                [ngClass]="{'is-invalid' :submitted && myFormGroup.get(form_elem.fieldid).errors,
																	'marginTopField': form_elem.marginTop == 'true',
                                                                    'marginTopFieldMediaScreen': form_elem.marginTopMediaScreen == 'true'}"
                                placeholder=" " />
                              <span class="highlight"></span>
                              <label class="effect-label">{{form_elem.label}}</label>
                            </label>
                          </div>
                        </div>

                        <div *ngIf="submitted && myFormGroup.get(form_elem.fieldid).errors" class="invalid-feedback">
                          <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.maxlength">
                            Too many characters. Max:
                            {{myFormGroup.get(form_elem.fieldid).errors.maxlength.requiredLength}}
                          </div>
                          <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.required">
                            This is a required field.
                          </div>
                          <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.minlength">
                            Not enough characters. Min:
                            {{myFormGroup.get(form_elem.fieldid).errors.minlength.requiredLength}}
                          </div>
                          <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.max">
                            Value too big. Max:
                            {{myFormGroup.get(form_elem.fieldid).errors.max.requiredLength}}
                          </div>
                          <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.min">
                            Value too small. Min:
                            {{myFormGroup.get(form_elem.fieldid).errors.min.requiredLength}}
                          </div>
                          <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.email">
                            Invalid email address
                          </div>
                          <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.notEquivalent">
                            These email addresses do not match
                          </div>
                        </div>
                      </div>
                    </section>

                    <section *ngSwitchCase="'radiobuttons'" class="radiobuttons-dynamic">
                      <div class="dynamic-item form-group">
                        <div *ngIf="form_elem.explanation.length>0" class="dynamic-info-btn-radiobuttons-dynamic"
                          ngbTooltip="{{form_elem.explanation}}" placement="{{form_elem.tooltipPlacement}}">
                          <!-- <img src="../../assets/img/info-btn.svg" height="35px" alt=""> -->
                          <div class="svg-container help-btn-svg-container">
                            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 832.46 905" width="30px">

                              <path
                                d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                              <path
                                d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                transform="translate(-95.77 -59.5)" fill="#fff" />
                              <path
                                d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                transform="translate(-95.77 -59.5)" class="svg-sign" />
                              <path
                                d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                transform="translate(-95.77 -59.5)" class="svg-sign" />
                            </svg>
                          </div>
                        </div>

                        <!-- Tooltip on mobile -->
                        <div *ngIf="statusTooltipMobile[i] && form_elem.explanation.length>0"
                          class="container-tooltip-show-mobile">
                          <div class="tooltip-show-mobile">{{form_elem.explanation}}</div>
                        </div>
                        <div class="info-mark-mobile" *ngIf="questionMarkMobile && form_elem.explanation.length>0"
                          (click)="statusTooltipMobile[i] = !statusTooltipMobile[i]">
                          <!-- <img src="../../assets/img/info-btn.svg" height="35px" alt="section logo" height="35px"> -->
                          <div class="svg-container help-btn-svg-container">
                            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 832.46 905" width="30px">

                              <path
                                d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                              <path
                                d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                transform="translate(-95.77 -59.5)" fill="#fff" />
                              <path
                                d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                transform="translate(-95.77 -59.5)" class="svg-sign" />
                              <path
                                d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                transform="translate(-95.77 -59.5)" class="svg-sign" />
                            </svg>
                          </div>
                        </div>

                        <div *ngIf="form_elem.presentationTitle==true" class="form-presentation">
                          <div class="title-section">{{form_elem.title}}</div>
                        </div>

                        <label>{{form_elem.label}}</label>

                        <div class="radio-buttons-container"
                          *ngFor="let item of form_elem.urlparameters; let i = index;">
                          <label class="check-label" [ngClass]="{paddingTopExplanations: item.explanation.length>0}">
                            {{item.option}}
                            <input type="radio" formControlName="{{form_elem.fieldid}}" value="{{item.option}}"
                              (click)="forkClick(item,form_elem.urlparameters)"
                              [ngClass]="{'is-invalid' :submitted && myFormGroup.get(form_elem.fieldid).errors}"
                              class="form-check-input" />
                            <span class="radio-label checkmark"
                              [ngClass]="{topExplanations: item.explanation.length>0}"></span>
                            <br>
                          </label>
                          <div *ngIf="item.explanation.length>0" class="dynamic-info-btn-radiobuttons"
                            ngbTooltip="{{item.explanation}}" placement="{{form_elem.tooltipPlacement}}">
                            <!-- <img src="../../assets/img/info-btn.svg" height="35px" alt=""> -->
                            <div class="svg-container help-btn-svg-container">
                              <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 832.46 905" width="30px">

                                <path
                                  d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                  transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                                <path
                                  d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                  transform="translate(-95.77 -59.5)" fill="#fff" />
                                <path
                                  d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                                <path
                                  d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                              </svg>
                            </div>
                          </div>

                          <div *ngIf="statusTooltipMobile[i] && item.explanation.length>0"
                            class="container-tooltip-show-mobile">
                            <div class="tooltip-show-mobile">{{item.explanation}}</div>
                          </div>
                          <div class="info-mark-mobile" *ngIf="questionMarkMobile && item.explanation.length>0"
                            (click)="statusTooltipMobile[i] = !statusTooltipMobile[i]">
                            <!-- <img src="../../assets/img/info-btn.svg" height="35px" alt="section logo" height="35px"> -->
                            <div class="svg-container help-btn-svg-container">
                              <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 832.46 905" width="30px">
                                <path
                                  d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                  transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                                <path
                                  d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                  transform="translate(-95.77 -59.5)" fill="#fff" />
                                <path
                                  d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                                <path
                                  d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                              </svg>
                            </div>
                          </div>
                        </div>

                        <div *ngIf="submitted && myFormGroup.get(form_elem.fieldid).errors" class="invalid-feedback">
                          <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.required">
                            This is a required field.
                          </div>
                        </div>
                      </div>
                    </section>

                    <section *ngSwitchCase="'freetextshowhide'" class="freetextshowhide-dynamic">
                      <ng-container *ngIf="form_elem.typeOfField!== 'formIntroduction'">
                        <ng-container *ngIf="dummyShowTrigger?showMe(form_elem.fieldid):showMe(form_elem.fieldid)">
                          <div class="dynamic-item">
                            <div class="form-group">
                              <div *ngIf="form_elem.explanation.length>0" class="dynamic-info-btn-freetext"
                                ngbTooltip="{{form_elem.explanation}}" placement="{{form_elem.tooltipPlacement}}">
                                <!-- <img src="../../assets/img/info-btn.svg" height="35px" alt=""> -->
                                <div class="svg-container help-btn-svg-container">
                                  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 832.46 905" width="30px">

                                    <path
                                      d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                      transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                                    <path
                                      d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                      transform="translate(-95.77 -59.5)" fill="#fff" />
                                    <path
                                      d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                      transform="translate(-95.77 -59.5)" class="svg-sign" />
                                    <path
                                      d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                      transform="translate(-95.77 -59.5)" class="svg-sign" />
                                  </svg>
                                </div>
                              </div>
                              <!-- Tooltip on mobile -->
                              <div *ngIf="statusTooltipMobile[i] && form_elem.explanation.length>0"
                                class="container-tooltip-show-mobile">
                                <div class="tooltip-show-mobile">{{form_elem.explanation}}</div>
                              </div>
                              <div class="info-mark-mobile" *ngIf="questionMarkMobile && form_elem.explanation.length>0"
                                (click)="statusTooltipMobile[i] = !statusTooltipMobile[i]">
                                <!-- <img src="../../assets/img/info-btn.svg" height="35px" alt="section logo" height="35px"> -->
                                <div class="svg-container help-btn-svg-container">
                                  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 832.46 905" width="30px">

                                    <path
                                      d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                      transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                                    <path
                                      d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                      transform="translate(-95.77 -59.5)" fill="#fff" />
                                    <path
                                      d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                      transform="translate(-95.77 -59.5)" class="svg-sign" />
                                    <path
                                      d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                      transform="translate(-95.77 -59.5)" class="svg-sign" />
                                  </svg>
                                </div>
                              </div>

                              <div class="dynamic-form-data-entry-input floating-form">
                                <div class="floating-label">
                                  <span class="required-field">{{form_elem.required}}</span>
                                  <span class="optional-field">{{form_elem.optional}}</span>
                                  <label class="label" for="{{form_elem.fieldid}}">
                                    <input type="text" class="form-control floating-input" placeholder=" "
                                      formControlName="{{form_elem.fieldid}}"
                                      [ngClass]="{'is-invalid' :submitted && myFormGroup.get(form_elem.fieldid).errors}" />
                                    <span class="highlight"></span>
                                    <label class="effect-label">{{form_elem.label}}</label>
                                  </label>
                                </div>
                              </div>

                              <div *ngIf="submitted && myFormGroup.get(form_elem.fieldid).errors"
                                class="invalid-feedback">
                                <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.maxlength">
                                  Too many characters. Max:
                                  {{myFormGroup.get(form_elem.fieldid).errors.maxlength.requiredLength}}
                                </div>
                                <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.required">
                                  This is a required field.
                                </div>
                                <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.minlength">
                                  Not enough characters. Min:
                                  {{myFormGroup.get(form_elem.fieldid).errors.minlength.requiredLength}}
                                </div>
                                <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.max">
                                  Value too big. Max:
                                  {{myFormGroup.get(form_elem.fieldid).errors.max.requiredLength}}
                                </div>
                                <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.min">
                                  Value too small. Min:
                                  {{myFormGroup.get(form_elem.fieldid).errors.min.requiredLength}}
                                </div>
                                <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.email">
                                  Invalid email address
                                </div>
                                <div *ngIf="myFormGroup.get(form_elem.fieldid).hasError('notEquivalent')">
                                  <div *ngIf="form_elem.fieldid=='confirmEmail'; else elseBlock">
                                    These email addresses do not match
                                  </div>
                                  <ng-template #elseBlock>
                                    The values must match to confirm.
                                  </ng-template>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-container>
                      </ng-container>
                      <ng-container *ngIf="form_elem.typeOfField=='formIntroduction'">
                        <div *ngIf="dummyShowTrigger?showMe(form_elem.fieldid):showMe(form_elem.fieldid)">
                          <div *ngIf="form_elem.fieldid=='formIntroduction'">
                            Test 1
                          </div>
                          <div *ngIf="form_elem.fieldid=='formIntroduction2'">
                            Test 2
                          </div>
                        </div>
                      </ng-container>
                    </section>

                    <section *ngSwitchCase="'infoshowhide'">
                      <div *ngIf="dummyShowTrigger?showMe(form_elem.fieldid):showMe(form_elem.fieldid)">
                        <div class="infoshowhide-dynamic banner">
                          <i class="info-fa start-info fa fas fa-info"></i>
                          <div>
                            <p *ngIf="form_elem.infoFirstPara">{{form_elem.infoFirstPara}}</p>
                            <p *ngIf="form_elem.infoScdPara">{{form_elem.infoScdPara}}</p>
                          </div>
                        </div>
                      </div>
                    </section>


                    <section *ngSwitchCase="'memo'" class="memo-dynamic">
                      <div class="dynamic-item form-group">
                        <div *ngIf="form_elem.explanation.length>0" class="dynamic-info-btn-memo-dynamic"
                          ngbTooltip="{{form_elem.explanation}}" placement="{{form_elem.tooltipPlacement}}">
                          <!-- <img src="../../assets/img/info-btn.svg" height="35px" alt=""> -->
                          <div class="svg-container help-btn-svg-container">
                            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 832.46 905" width="30px">

                              <path
                                d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                              <path
                                d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                transform="translate(-95.77 -59.5)" fill="#fff" />
                              <path
                                d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                transform="translate(-95.77 -59.5)" class="svg-sign" />
                              <path
                                d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                transform="translate(-95.77 -59.5)" class="svg-sign" />
                            </svg>
                          </div>
                        </div>
                        <!-- Tooltip on mobile -->
                        <div *ngIf="statusTooltipMobile[i] && form_elem.explanation.length>0"
                          class="container-tooltip-show-mobile">
                          <div class="tooltip-show-mobile">{{form_elem.explanation}}</div>
                        </div>
                        <div class="info-mark-mobile" *ngIf="questionMarkMobile && form_elem.explanation.length>0"
                          (click)="statusTooltipMobile[i] = !statusTooltipMobile[i]">
                          <!-- <img src="../../assets/img/info-btn.svg" height="35px" alt="section logo" height="35px"> -->
                          <div class="svg-container help-btn-svg-container">
                            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 832.46 905" width="30px">

                              <path
                                d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                              <path
                                d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                transform="translate(-95.77 -59.5)" fill="#fff" />
                              <path
                                d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                transform="translate(-95.77 -59.5)" class="svg-sign" />
                              <path
                                d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                transform="translate(-95.77 -59.5)" class="svg-sign" />
                            </svg>
                          </div>
                        </div>

                        <div class="dynamic-form-data-entry-input floating-form">
                          <div class="floating-label">
                            <span class="optional-field">{{form_elem.optional}}</span>
                            <textarea class="form-control floating-input floating-textarea" placeholder=" "
                              formControlName="{{form_elem.fieldid}}" rows="5" maxlength="300" (keyup)="checkOnKeyUp()"
                              [ngClass]="{'is-invalid' :submitted && myFormGroup.get(form_elem.fieldid).errors,
                              'high-notes-box': form_elem.fieldid == 'notes',
                              'high-box-letter-quotta': letterQuota == true}">
                            </textarea>

                            <div class="invalid-feedback" *ngIf="letterQuota">
                              {{textAreaModel.length}}/300 letters.</div>
                            <span class="highlight"></span>
                            <label class="effect-label">{{form_elem.label}}</label>
                          </div>
                        </div>

                        <div *ngIf="submitted && myFormGroup.get(form_elem.fieldid).errors" class="invalid-feedback">
                          <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.maxlength">Too
                            many
                            characters. Max:
                            {{myFormGroup.get(form_elem.fieldid).errors.maxlength.requiredLength}}
                          </div>
                          <div *ngIf="myFormGroup.get(form.fieldid).errors.required">This is a
                            required field.
                          </div>
                          <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.minlength">Not
                            enough
                            characters. Min:
                            {{myFormGroup.get(form_elem.fieldid).errors.minlength.requiredLength}}
                          </div>
                          <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.max">Value too
                            big. Max:
                            {{myFormGroup.get(form_elem.fieldid).errors.max.requiredLength}}
                          </div>
                          <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.min">Value too
                            small. Min:
                            {{myFormGroup.get(form_elem.fieldid).errors.min.requiredLength}}
                          </div>
                          <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.email">Invalid
                            email
                            address
                          </div>
                        </div>
                      </div>
                    </section>

                    <section *ngSwitchCase="'memoshow'" class="memoshow-dynamic">
                      <div *ngIf="dummyShowTrigger?showMe(form_elem.fieldid):showMe(form_elem.fieldid)">
                        <div class="dynamic-item form-group">
                          <div *ngIf="form_elem.explanation.length>0" class="dynamic-info-btn-freetext"
                            ngbTooltip="{{form_elem.explanation}}" placement="{{form_elem.tooltipPlacement}}">
                            <!-- <img src="../../assets/img/info-btn.svg" height="35px" alt=""> -->
                            <div class="svg-container help-btn-svg-container">
                              <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 832.46 905" width="30px">

                                <path
                                  d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                  transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                                <path
                                  d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                  transform="translate(-95.77 -59.5)" fill="#fff" />
                                <path
                                  d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                                <path
                                  d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                              </svg>
                            </div>
                          </div>
                          <!-- Tooltip on mobile -->
                          <div *ngIf="statusTooltipMobile[i] && form_elem.explanation.length>0"
                            class="container-tooltip-show-mobile">
                            <div class="tooltip-show-mobile">{{form_elem.explanation}}</div>
                          </div>
                          <div class="info-mark-mobile" *ngIf="questionMarkMobile && form_elem.explanation.length>0"
                            (click)="statusTooltipMobile[i] = !statusTooltipMobile[i]">
                            <!-- <img src="../../assets/img/info-btn.svg" height="35px" alt="section logo" height="35px"> -->
                            <div class="svg-container help-btn-svg-container">
                              <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 832.46 905" width="30px">

                                <path
                                  d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                  transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                                <path
                                  d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                  transform="translate(-95.77 -59.5)" fill="#fff" />
                                <path
                                  d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                                <path
                                  d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                              </svg>
                            </div>
                          </div>

                          <div class="dynamic-form-data-entry-input floating-form">
                            <div class="floating-label">
                              <span class="required-field">{{form_elem.required}}</span>
                              <span class="optional-field">{{form_elem.optional}}</span>
                              <textarea class="form-control floating-input floating-textarea" placeholder=" "
                                formControlName="{{form_elem.fieldid}}" rows="5" maxlength="300"
                                (keyup)="checkOnKeyUp()"
                                [ngClass]="{'is-invalid' :submitted && myFormGroup.get(form_elem.fieldid).errors,
                                                                        'high-notes-box': form_elem.fieldid == 'notes',
                                                                        'high-box-letter-quotta': letterQuota == true}">
                                                        </textarea>
                              <div class="invalid-feedback" *ngIf="letterQuota">
                                {{textAreaModel.length}}/300 letters.</div>
                              <span class="highlight"></span>
                              <label class="effect-label">{{form_elem.label}}</label>
                            </div>
                          </div>

                          <div *ngIf="submitted && myFormGroup.get(form_elem.fieldid).errors" class="invalid-feedback">
                            <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.maxlength">
                              Too many
                              characters. Max:
                              {{myFormGroup.get(form_elem.fieldid).errors.maxlength.requiredLength}}
                            </div>
                            <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.required">
                              This is a
                              required field.
                            </div>
                            <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.minlength">
                              Not enough
                              characters. Min:
                              {{myFormGroup.get(form_elem.fieldid).errors.minlength.requiredLength}}
                            </div>
                            <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.max">Value
                              too big.
                              Max:
                              {{myFormGroup.get(form_elem.fieldid).errors.max.requiredLength}}
                            </div>
                            <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.min">Value
                              too small.
                              Min:
                              {{myFormGroup.get(form_elem.fieldid).errors.min.requiredLength}}
                            </div>
                            <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.email">
                              Invalid email
                              address
                            </div>
                          </div>
                          <div class="required-field">{{form_elem.required}}</div>
                        </div>
                      </div>
                    </section>

                    <section *ngSwitchCase="'memofreeshow'" class="memofreeshow-dynamic">
                      <div *ngIf="dummyShowTrigger?showMe(form_elem.fieldid):showMe(form_elem.fieldid)">
                        <div class="dynamic-item form-group">
                          <div *ngIf="form_elem.explanation.length>0" class="dynamic-info-btn-freetext"
                            ngbTooltip="{{form_elem.explanation}}" placement="{{form_elem.tooltipPlacement}}">
                            <!-- <img src="../../assets/img/info-btn.svg" height="35px" alt=""> -->
                            <div class="svg-container help-btn-svg-container">
                              <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 832.46 905" width="30px">

                                <path
                                  d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                  transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                                <path
                                  d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                  transform="translate(-95.77 -59.5)" fill="#fff" />
                                <path
                                  d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                                <path
                                  d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                              </svg>
                            </div>
                          </div>
                          <!-- Tooltip on mobile -->
                          <div *ngIf="statusTooltipMobile[i] && form_elem.explanation.length>0"
                            class="container-tooltip-show-mobile">
                            <div class="tooltip-show-mobile">{{form_elem.explanation}}</div>
                          </div>
                          <div class="info-mark-mobile" *ngIf="questionMarkMobile && form_elem.explanation.length>0"
                            (click)="statusTooltipMobile[i] = !statusTooltipMobile[i]">
                            <!-- <img src="../../assets/img/info-btn.svg" height="35px" alt="section logo" height="35px"> -->
                            <div class="svg-container help-btn-svg-container">
                              <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 832.46 905" width="30px">

                                <path
                                  d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                  transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                                <path
                                  d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                  transform="translate(-95.77 -59.5)" fill="#fff" />
                                <path
                                  d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                                <path
                                  d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                              </svg>
                            </div>
                          </div>

                          <div class="dynamic-form-data-entry-input floating-form">
                            <div class="floating-label">
                              <span class="required-field">{{form_elem.required}}</span>
                              <span class="optional-field">{{form_elem.optional}}</span>
                              <textarea class="form-control floating-input floating-textarea" maxlength="300" rows="5"
                                placeholder=" " formControlName="{{form_elem.fieldid}}" (keyup)="checkOnKeyUp()"
                                [ngClass]="{'is-invalid' :submitted && myFormGroup.get(form_elem.fieldid).errors,
                                                                        'high-box-letter-quotta': letterQuota == true}">
                                                        </textarea>
                              <div class="invalid-feedback" *ngIf="letterQuota">
                                {{textAreaModel.length}}/300 letters.</div>
                              <span class="highlight"></span>
                              <label class="effect-label">{{form_elem.label}}</label>
                            </div>
                          </div>

                          <div *ngIf="submitted && myFormGroup.get(form_elem.fieldid).errors" class="invalid-feedback">
                            <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.maxlength">
                              Too many
                              characters. Max:
                              {{myFormGroup.get(form_elem.fieldid).errors.maxlength.requiredLength}}
                            </div>
                            <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.required">
                              This is a
                              required field.
                            </div>
                            <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.minlength">
                              Not enough
                              characters. Min:
                              {{myFormGroup.get(form_elem.fieldid).errors.minlength.requiredLength}}
                            </div>
                            <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.max">Value
                              too big.
                              Max:
                              {{myFormGroup.get(form_elem.fieldid).errors.max.requiredLength}}
                            </div>
                            <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.min">Value
                              too small.
                              Min:
                              {{myFormGroup.get(form_elem.fieldid).errors.min.requiredLength}}
                            </div>
                            <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.email">
                              Invalid email
                              address
                            </div>
                          </div>

                        </div>
                      </div>
                    </section>

                    <section *ngSwitchCase="'memofree'" class="memofree-dynamic">
                      <div class="dynamic-item form-group">
                        <div *ngIf="form_elem.explanation.length>0" class="dynamic-info-btn-freetext"
                          ngbTooltip="{{form_elem.explanation}}" placement="{{form_elem.tooltipPlacement}}">
                          <!-- <img src="../../assets/img/info-btn.svg" height="35px" alt=""> -->
                          <div class="svg-container help-btn-svg-container">
                            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 832.46 905" width="30px">

                              <path
                                d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                              <path
                                d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                transform="translate(-95.77 -59.5)" fill="#fff" />
                              <path
                                d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                transform="translate(-95.77 -59.5)" class="svg-sign" />
                              <path
                                d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                transform="translate(-95.77 -59.5)" class="svg-sign" />
                            </svg>
                          </div>
                        </div>
                        <!-- Tooltip on mobile -->
                        <div *ngIf="statusTooltipMobile[i] && form_elem.explanation.length>0"
                          class="container-tooltip-show-mobile">
                          <div class="tooltip-show-mobile">{{form_elem.explanation}}</div>
                        </div>
                        <div class="info-mark-mobile" *ngIf="questionMarkMobile && form_elem.explanation.length>0"
                          (click)="statusTooltipMobile[i] = !statusTooltipMobile[i]">
                          <!-- <img src="../../assets/img/info-btn.svg" height="35px" alt="section logo" height="35px"> -->
                          <div class="svg-container help-btn-svg-container">
                            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 832.46 905" width="30px">

                              <path
                                d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                              <path
                                d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                transform="translate(-95.77 -59.5)" fill="#fff" />
                              <path
                                d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                transform="translate(-95.77 -59.5)" class="svg-sign" />
                              <path
                                d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                transform="translate(-95.77 -59.5)" class="svg-sign" />
                            </svg>
                          </div>
                        </div>

                        <div class="dynamic-form-data-entry-input floating-form">
                          <div class="floating-label">
                            <span class="required-field">{{form_elem.required}}</span>
                            <span class="optional-field">{{form_elem.optional}}</span>
                            <textarea class="form-control floating-input floating-textarea" rows="5" maxlength="300"
                              placeholder=" " formControlName="{{form_elem.fieldid}}" (keyup)="checkOnKeyUp()"
                              [ngClass]="{'is-invalid' :submitted && myFormGroup.get(form_elem.fieldid).errors,
                                                                    'high-notes-box': form_elem.fieldid == 'invitation',
                                                                    'marginTopFieldMediaScreen': form_elem.marginTopMediaScreen == 'true',
                                                                    'high-box-letter-quotta': letterQuota == true}">
                                                    </textarea>
                            <div class="invalid-feedback" *ngIf="letterQuota">
                              {{textAreaModel.length}}/300 letters.</div>
                            <span class="highlight"></span>
                            <label class="effect-label">{{form_elem.label}}</label>
                          </div>
                        </div>

                        <div *ngIf="submitted && myFormGroup.get(form_elem.fieldid).errors" class="invalid-feedback">
                          <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.maxlength">Too
                            many
                            characters. Max:
                            {{myFormGroup.get(form_elem.fieldid).errors.maxlength.requiredLength}}
                          </div>
                          <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.required">This
                            is a
                            required field.
                          </div>
                          <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.minlength">Not
                            enough
                            characters. Min:
                            {{myFormGroup.get(form_elem.fieldid).errors.minlength.requiredLength}}
                          </div>
                          <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.max">Value too
                            big. Max:
                            {{myFormGroup.get(form_elem.fieldid).errors.max.requiredLength}}
                          </div>
                          <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.min">Value too
                            small. Min:
                            {{myFormGroup.get(form_elem.fieldid).errors.min.requiredLength}}
                          </div>
                          <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.email">Invalid
                            email
                            address
                          </div>
                        </div>
                      </div>
                    </section>

                    <section *ngSwitchCase="'number'">
                      <div class="dynamic-item form-group">
                        <div *ngIf="form_elem.explanation.length>0" class="dynamic-info-btn-freetext"
                          ngbTooltip="{{form_elem.explanation}}" placement="{{form_elem.tooltipPlacement}}">
                          <!-- <img src="../../assets/img/info-btn.svg" height="35px" alt=""> -->
                          <div class="svg-container help-btn-svg-container">
                            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 832.46 905" width="30px">

                              <path
                                d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                              <path
                                d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                transform="translate(-95.77 -59.5)" fill="#fff" />
                              <path
                                d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                transform="translate(-95.77 -59.5)" class="svg-sign" />
                              <path
                                d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                transform="translate(-95.77 -59.5)" class="svg-sign" />
                            </svg>
                          </div>
                        </div>
                        <!-- Tooltip on mobile -->
                        <div *ngIf="statusTooltipMobile[i] && form_elem.explanation.length>0"
                          class="container-tooltip-show-mobile">
                          <div class="tooltip-show-mobile">{{form_elem.explanation}}</div>
                        </div>
                        <div class="info-mark-mobile" *ngIf="questionMarkMobile && form_elem.explanation.length>0"
                          (click)="statusTooltipMobile[i] = !statusTooltipMobile[i]">
                          <!-- <img src="../../assets/img/info-btn.svg" height="35px" alt="section logo" height="35px"> -->
                          <div class="svg-container help-btn-svg-container">
                            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 832.46 905" width="30px">

                              <path
                                d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                              <path
                                d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                transform="translate(-95.77 -59.5)" fill="#fff" />
                              <path
                                d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                transform="translate(-95.77 -59.5)" class="svg-sign" />
                              <path
                                d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                transform="translate(-95.77 -59.5)" class="svg-sign" />
                            </svg>
                          </div>
                        </div>


                        <div class="dynamic-form-data-entry-input form-group floating-form">
                          <span class="required-field">{{form_elem.required}}</span>
                          <span *ngIf="form_elem.optional!='£'" class="optional-field">
                            {{form_elem.optional}}
                          </span>

                          <!-- Dynamic Form Data -->
                          <ng-container *ngIf="form_elem.currency && !isDE">
                            <!-- <div class="dynamic-currency-container"> -->
                            <app-dynamic-currency [invalid]="submitted && myFormGroup.get(form_elem.fieldid).errors"
                              [myLabel]="form_elem.label" [fieldId]="form_elem.fieldid" [type]="'number'"
                              (currencyToEmit)="getCurrencyValue($event)">
                            </app-dynamic-currency>
                            <!-- </div> -->

                            <!-- <div class="floating-label number 4">
                              <label class="label" for="{{form_elem.fieldid}}">
                                <input class="form-control floating-input" placeholder=" " type="hidden"
                                  formControlName="{{form_elem.fieldid}}"
                                  [ngClass]="{'is-invalid' :submitted && myFormGroup.get(form_elem.fieldid).errors}" />
                              </label>
                            </div> -->
                          </ng-container>

                          <!-- Dynamic Edit -->
                          <ng-container *ngIf="form_elem.currency && isDE">
                            <div>
                              <app-dynamic-currency [invalid]="submitted && myFormGroup.get(form_elem.fieldid).errors"
                                [myLabel]="form_elem.label" [fieldId]="form_elem.fieldid"
                                [currencyValue]="getPreviousCurrencyValue(form_elem.fieldid)"
                                (currencyToEmit)="getCurrencyValue($event)">
                              </app-dynamic-currency>
                            </div>

                            <!-- <div class="floating-label"> -->
                            <label class="label" for="{{form_elem.fieldid}}">
                              <input class="form-control number2 number1-edit floating-input" placeholder=" "
                                type="hidden" formControlName="{{form_elem.fieldid}}"
                                [ngClass]="{'is-invalid' :submitted && myFormGroup.get(form_elem.fieldid).errors}" />
                              <span class="highlight"></span>
                              <label class="effect-label">{{form_elem.label}}</label>
                            </label>
                            <!-- </div> -->
                          </ng-container>

                          <!-- Dynamic Form Data BUT not currency -->
                          <div *ngIf="!form_elem.currency" class="floating-label number2">
                            <label class="label" for="{{form_elem.fieldid}}">
                              <input class="form-control number1 floating-input" placeholder=" " type="number"
                                formControlName="{{form_elem.fieldid}}"
                                [ngClass]="{'is-invalid' :submitted && myFormGroup.get(form_elem.fieldid).errors}" />
                              <span class="highlight"></span>
                              <label class="effect-label">{{form_elem.label}}</label>
                            </label>
                          </div>
                        </div>

                        <div *ngIf="submitted && myFormGroup.get(form_elem.fieldid).errors" class="invalid-feedback">
                          <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.required">This
                            is a
                            required field.
                          </div>
                          <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.max">Value too
                            big. Max:
                            {{myFormGroup.get(form_elem.fieldid).errors.max.requiredLength}}
                          </div>
                          <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.min">Value too
                            small. Min:
                            {{myFormGroup.get(form_elem.fieldid).errors.min.requiredLength}}
                          </div>
                          <!-- Dynamic Form Data -->
                          <ng-container *ngIf="form_elem.currency && !isDE">
                            <div>
                              <app-dynamic-currency [invalid]="submitted && myFormGroup.get(form_elem.fieldid).errors"
                                [myLabel]="form_elem.label" [fieldId]="form_elem.fieldid" [type]="'number'"
                                (currencyToEmit)="getCurrencyValue($event)">
                              </app-dynamic-currency>
                            </div>

                            <div class="floating-label number3">
                              <label class="label" for="{{form_elem.fieldid}}">
                                <input class="form-control floating-input" placeholder=" " type="hidden"
                                  formControlName="{{form_elem.fieldid}}"
                                  [ngClass]="{'is-invalid' :submitted && myFormGroup.get(form_elem.fieldid).errors}" />
                                <!-- <span class="highlight"></span>
                                                                <label class="effect-label">{{form_elem.label}}</label> -->
                              </label>
                            </div>
                          </ng-container>

                          <!-- Dynamic Edit -->
                          <ng-container *ngIf="form_elem.currency && isDE">
                            <div>
                              <app-dynamic-currency [invalid]="submitted && myFormGroup.get(form_elem.fieldid).errors"
                                [myLabel]="form_elem.label" [fieldId]="form_elem.fieldid"
                                [currencyValue]="getPreviousCurrencyValue(form_elem.fieldid)"
                                (currencyToEmit)="getCurrencyValue($event)">
                              </app-dynamic-currency>
                            </div>

                            <div class="floating-label">
                              <label class="label" for="{{form_elem.fieldid}}">
                                <input class="form-control number1-edit floating-input" placeholder=" " type="hidden"
                                  formControlName="{{form_elem.fieldid}}"
                                  [ngClass]="{'is-invalid' :submitted && myFormGroup.get(form_elem.fieldid).errors}" />
                              </label>
                            </div>
                          </ng-container>

                          <!-- Dynamic Form Data BUT not currency -->
                          <div *ngIf="!form_elem.currency" class="floating-label">
                            <label class="label" for="{{form_elem.fieldid}}">
                              <input class="form-control number1 floating-input" placeholder=" " type="number"
                                formControlName="{{form_elem.fieldid}}"
                                [ngClass]="{'is-invalid' :submitted && myFormGroup.get(form_elem.fieldid).errors}" />
                              <span class="highlight"></span>
                              <label class="effect-label">{{form_elem.label}}</label>
                            </label>
                          </div>
                        </div>
                      </div>
                    </section>

                    <section *ngSwitchCase="'numbershow'" class="numbershow-dynamic">
                      <div *ngIf="dummyShowTrigger?showMe(form_elem.fieldid):showMe(form_elem.fieldid)">
                        <div class="dynamic-item form-group">

                          <div *ngIf="form_elem.explanation.length>0" class="dynamic-info-btn-freetext"
                            ngbTooltip="{{form_elem.explanation}}" placement="{{form_elem.tooltipPlacement}}">
                            <!-- <img src="../../assets/img/info-btn.svg" height="35px" alt=""> -->
                            <div class="svg-container help-btn-svg-container">
                              <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 832.46 905" width="30px">

                                <path
                                  d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                  transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                                <path
                                  d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                  transform="translate(-95.77 -59.5)" fill="#fff" />
                                <path
                                  d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                                <path
                                  d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                              </svg>
                            </div>
                          </div>
                          <!-- Tooltip on mobile -->
                          <div *ngIf="statusTooltipMobile[i] && form_elem.explanation.length>0"
                            class="container-tooltip-show-mobile">
                            <div class="tooltip-show-mobile">{{form_elem.explanation}}</div>
                          </div>
                          <div class="info-mark-mobile" *ngIf="questionMarkMobile && form_elem.explanation.length>0"
                            (click)="statusTooltipMobile[i] = !statusTooltipMobile[i]">
                            <!-- <img src="../../assets/img/info-btn.svg" height="35px"
                                                        alt="section logo" height="35px"> -->
                            <div class="svg-container help-btn-svg-container">
                              <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 832.46 905" width="30px">

                                <path
                                  d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                  transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                                <path
                                  d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                  transform="translate(-95.77 -59.5)" fill="#fff" />
                                <path
                                  d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                                <path
                                  d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                              </svg>
                            </div>
                          </div>

                          <div class="dynamic-form-data-entry-input floating-form">

                            <!-- Dynamic Form Data -->
                            <ng-container *ngIf="form_elem.currency && !isDE">
                              <div>
                                <app-dynamic-currency [invalid]="submitted && myFormGroup.get(form_elem.fieldid).errors"
                                  formControlName="{{form_elem.fieldid}}" [myLabel]="form_elem.label"
                                  [fieldId]="form_elem.fieldid" (currencyToEmit)="getCurrencyValue($event)">
                                </app-dynamic-currency>
                              </div>

                              <div class="floating-label">
                                <label class="label" for="{{form_elem.fieldid}}">
                                  <input class="form-control floating-input" placeholder=" " type="hidden"
                                    formControlName="{{form_elem.fieldid}}"
                                    [ngClass]="{'is-invalid' :submitted && myFormGroup.get(form_elem.fieldid).errors}" />
                                  <!-- <span class="highlight"></span>
                                                                    <label class="effect-label">{{form_elem.label}}</label> -->
                                </label>
                              </div>
                            </ng-container>

                            <!-- Dynamic Edit -->
                            <ng-container *ngIf="form_elem.currency && isDE">
                              <div>
                                <app-dynamic-currency [invalid]="submitted && myFormGroup.get(form_elem.fieldid).errors"
                                  [myLabel]="form_elem.label" [fieldId]="form_elem.fieldid"
                                  [currencyValue]="getPreviousCurrencyValue(form_elem.fieldid)"
                                  (currencyToEmit)="getCurrencyValue($event)">
                                </app-dynamic-currency>
                              </div>

                              <div class="floating-label">
                                <label class="label" for="{{form_elem.fieldid}}">
                                  <input class="form-control number1-edit floating-input" placeholder=" " type="hidden"
                                    formControlName="{{form_elem.fieldid}}"
                                    [ngClass]="{'is-invalid' :submitted && myFormGroup.get(form_elem.fieldid).errors}" />
                                </label>
                              </div>
                            </ng-container>

                            <!-- Dynamic Form Data BUT not currency -->
                            <div class="floating-label" *ngIf="!form_elem.currency">
                              <label class="label" for="{{form_elem.fieldid}}">
                                <span class="required-field">{{form_elem.required}}</span>
                                <span class="optional-field">{{form_elem.optional}}</span>
                                <input class="form-control number3 floating-input" type="number" placeholder=" "
                                  formControlName="{{form_elem.fieldid}}" min="0" max="10000000000"
                                  [ngClass]="{'is-invalid' :submitted && myFormGroup.get(form_elem.fieldid).errors}" />{{form_elem.percent}}
                                <span class="highlight"></span>
                                <label class="effect-label">{{form_elem.label}}</label>
                              </label>
                            </div>

                            <div *ngIf="submitted && myFormGroup.get(form_elem.fieldid).errors"
                              class="invalid-feedback">
                              <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.required">
                                This is a
                                required field.
                              </div>
                              <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.max">Value
                                too big.
                                Max:
                                {{myFormGroup.get(form_elem.fieldid).errors.max.requiredLength}}
                              </div>
                              <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.min">Value
                                too small.
                                Min:
                                {{myFormGroup.get(form_elem.fieldid).errors.min.requiredLength}}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>

                    <section *ngSwitchCase="'dropdown'" class="dropdown-dynamic-1">
                      <div *ngIf="dummyShowTrigger?showMe(form_elem.fieldid):showMe(form_elem.fieldid)">
                        <div class="dynamic-item form-group">
                          <div *ngIf="form_elem.explanation.length>0" class="dynamic-info-btn-freetext"
                            ngbTooltip="{{form_elem.explanation}}" placement="{{form_elem.tooltipPlacement}}">
                            <!-- <img src="../../assets/img/info-btn.svg" height="35px" alt=""> -->
                            <div class="svg-container help-btn-svg-container">
                              <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 832.46 905" width="30px">

                                <path
                                  d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                  transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                                <path
                                  d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                  transform="translate(-95.77 -59.5)" fill="#fff" />
                                <path
                                  d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                                <path
                                  d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                              </svg>
                            </div>
                          </div>
                          <!-- Tooltip on mobile -->
                          <div *ngIf="statusTooltipMobile[i] && form_elem.explanation.length>0"
                            class="container-tooltip-show-mobile">
                            <div class="tooltip-show-mobile">{{form_elem.explanation}}</div>
                          </div>
                          <div class="info-mark-mobile" *ngIf="questionMarkMobile && form_elem.explanation.length>0"
                            (click)="statusTooltipMobile[i] = !statusTooltipMobile[i]">
                            <!-- <img src="../../assets/img/info-btn.svg" height="35px"
                                                        alt="section logo" height="35px"> -->
                            <div class="svg-container help-btn-svg-container">
                              <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 832.46 905" width="30px">

                                <path
                                  d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                  transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                                <path
                                  d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                  transform="translate(-95.77 -59.5)" fill="#fff" />
                                <path
                                  d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                                <path
                                  d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                              </svg>
                            </div>
                          </div>

                          <!-- Delegates titles -->
                          <h2 class="delegates-explanations" *ngIf="form_elem.subtitles">
                            {{form_elem.subtitles}}
                            <img *ngIf="form_elem.assetsImg == 'true'"
                              src="../../assets/img/{{themeService.theme}}/assets.svg" alt="Assets Img">
                            <img *ngIf="form_elem.debtsImg == 'true'"
                              src="../../assets/img/{{themeService.theme}}/debts.svg" alt="Debts Img">
                            <img *ngIf="form_elem.dailyLifeImg == 'true'"
                              src="../../assets/img/{{themeService.theme}}/daily-life.svg" alt="Daily Life Img">
                            <img *ngIf="form_elem.digitalLifeImg == 'true'"
                              src="../../assets/img/{{themeService.theme}}/digital-life.svg" alt="Digital Life Img">
                            <img *ngIf="form_elem.wishesImg == 'true'"
                              src="../../assets/img/{{themeService.theme}}/wishes.svg" alt="Wishes Img">
                          </h2>

                          <app-dynamic-dropdown *ngIf="isIE && !isDE" [myUser]="myUser"
                            [invalid]="submitted && myFormGroup.get(form_elem.fieldid).errors"
                            formControlName="{{form_elem.fieldid}}" [myLabel]="form_elem.label" [id]="form_elem.fieldid"
                            [optionCollection]="form_elem.items" [optionViewProperty]="opt" [optionValueProperty]="opt"
                            [required]="form_elem.required" [optional]="form_elem.optional">
                          </app-dynamic-dropdown>

                          <app-dynamic-dropdown *ngIf="(!isIE && !isDE) || myFormTemplate.aboutMe == true"
                            [myUser]="myUser" [invalid]="submitted && myFormGroup.get(form_elem.fieldid).errors"
                            formControlName="{{form_elem.fieldid}}" [myLabel]="form_elem.label" [id]="form_elem.fieldid"
                            [optionCollection]="form_elem.items" [optionViewProperty]="opt" [optionValueProperty]="opt"
                            [required]="form_elem.required" [optional]="form_elem.optional">
                          </app-dynamic-dropdown>

                          <label class="ovale" *ngIf="isDE && !myFormTemplate.aboutMe == true"
                            for="{{form_elem.fieldid}}">{{form_elem.label}}</label>
                          <div *ngIf="isIE && isDE && !myFormTemplate.aboutMe == true">
                            <div class="dynamic-form-data-entry-input">
                              <span class="required-field">{{form_elem.required}}</span>
                              <span class="optional-field">{{form_elem.optional}}</span>
                              <select class="form-control" formControlName="{{form_elem.fieldid}}"
                                [(ngModel)]="selectedValue"
                                [ngClass]="{'is-invalid' :submitted && myFormGroup.get(form_elem.fieldid).errors}"
                                [disabled]="selectFixBool">
                                <option>Select Option</option>
                                <option *ngFor="let opt of form_elem.items" value="{{opt}}">
                                  {{opt}}
                                </option>
                              </select>
                            </div>
                          </div>

                          <div *ngIf="!isIE && isDE && !myFormTemplate.aboutMe == true">
                            <div class="dynamic-form-data-entry-input">
                              <span class="required-field">{{form_elem.required}}</span>
                              <span class="optional-field">{{form_elem.optional}}</span>
                              <select class="form-control" formControlName="{{form_elem.fieldid}}"
                                [(ngModel)]="form_elem.explanationPermission"
                                [ngClass]="{'is-invalid' :submitted && myFormGroup.get(form_elem.fieldid).errors}">
                                <option *ngFor="let opt of form_elem.items" value="{{opt}}">
                                  {{opt}}
                                </option>
                              </select>
                            </div>
                          </div>

                          <div *ngIf="submitted && myFormGroup.get(form_elem.fieldid).errors" class="invalid-feedback">
                            <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.required">
                              This
                              is a
                              required
                              field.
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>

                    <section *ngSwitchCase="'dropdownid'" class="dropdown-dynamic">
                      <div *ngIf="dummyShowTrigger?showMe(form_elem.fieldid):showMe(form_elem.fieldid)">
                        <div class="dynamic-item form-group">

                          <div *ngIf="form_elem.explanation.length>0" class="dynamic-info-btn-freetext"
                            ngbTooltip="{{form_elem.explanation}}" placement="{{form_elem.tooltipPlacement}}">
                            <!-- <img src="../../assets/img/info-btn.svg" height="35px" alt=""> -->
                            <div class="svg-container help-btn-svg-container">
                              <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 832.46 905" width="30px">

                                <path
                                  d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                  transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                                <path
                                  d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                  transform="translate(-95.77 -59.5)" fill="#fff" />
                                <path
                                  d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                                <path
                                  d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                              </svg>
                            </div>
                          </div>
                          <!-- Tooltip on mobile -->
                          <div *ngIf="statusTooltipMobile[i] && form_elem.explanation.length>0"
                            class="container-tooltip-show-mobile">
                            <div class="tooltip-show-mobile">{{form_elem.explanation}}</div>
                          </div>
                          <div class="info-mark-mobile" *ngIf="questionMarkMobile && form_elem.explanation.length>0"
                            (click)="statusTooltipMobile[i] = !statusTooltipMobile[i]">
                            <!-- <img src="../../assets/img/info-btn.svg" height="35px"
                                                        alt="section logo" height="35px"> -->
                            <div class="svg-container help-btn-svg-container">
                              <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 832.46 905" width="30px">

                                <path
                                  d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                  transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                                <path
                                  d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                  transform="translate(-95.77 -59.5)" fill="#fff" />
                                <path
                                  d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                                <path
                                  d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                              </svg>
                            </div>
                          </div>

                          <app-dynamic-dropdown *ngIf="isIE && !isDE" [myUser]="myUser"
                            [invalid]="submitted && myFormGroup.get(form_elem.fieldid).errors"
                            formControlName="{{form_elem.fieldid}}" [myLabel]="form_elem.label" [id]="form_elem.fieldid"
                            [optionCollection]="form_elem.itemArray" [optionViewProperty]="'itemName'"
                            [optionValueProperty]="'Id'" [required]="form_elem.required"
                            [optional]="form_elem.optional">
                          </app-dynamic-dropdown>

                          <app-dynamic-dropdown *ngIf="!isIE && !isDE" [myUser]="myUser"
                            [invalid]="submitted && myFormGroup.get(form_elem.fieldid).errors"
                            formControlName="{{form_elem.fieldid}}" [myLabel]="form_elem.label" [id]="form_elem.fieldid"
                            [optionCollection]="form_elem.itemArray" [optionViewProperty]="'itemName'"
                            [optionValueProperty]="'Id'" [required]="form_elem.required"
                            [optional]="form_elem.optional">
                          </app-dynamic-dropdown>

                          <label class="ovale" *ngIf="isDE" for="{{form_elem.fieldid}}">{{form_elem.label}}</label>
                          <div *ngIf="isIE && isDE">
                            <div class="dynamic-form-data-entry-input">
                              <span class="required-field">{{form_elem.required}}</span>
                              <span class="optional-field">{{form_elem.optional}}</span>
                              <select class="form-control" formControlName="{{form_elem.fieldid}}"
                                id="{{form_elem.fieldid}}"
                                [ngClass]="{'is-invalid' :submitted && myFormGroup.get(form_elem.fieldid).errors}">
                                <option>Select Option</option>
                                <option *ngFor="let opt of form_elem.itemArray" value="{{opt.Id}}">
                                  {{opt.itemName}}
                                </option>
                              </select>
                            </div>
                          </div>

                          <div *ngIf="!isIE && isDE">
                            <div class="dynamic-form-data-entry-input">
                              <span class="required-field">{{form_elem.required}}</span>
                              <span class="optional-field">{{form_elem.optional}}</span>
                              <select class="form-control" formControlName="{{form_elem.fieldid}}"
                                id="{{form_elem.fieldid}}"
                                [ngClass]="{'is-invalid' :submitted && myFormGroup.get(form_elem.fieldid).errors}">

                                <option *ngFor="let opt of form_elem.itemArray" value="{{opt.Id}}">
                                  {{opt.itemName}}
                                </option>
                              </select>
                            </div>
                          </div>

                          <div *ngIf="submitted && myFormGroup.get(form_elem.fieldid).errors" class="invalid-feedback">
                            <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.required">
                              This
                              is a
                              required
                              field.
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>

                    <section *ngSwitchCase="'dropdowncountries'" class="dropdowncountries-dynamic">
                      <div class="dynamic-item  form-group">

                        <app-dynamic-dropdown *ngIf="isIE && !isDE" [myUser]="myUser"
                          [invalid]="submitted && myFormGroup.get(form_elem.fieldid).errors"
                          formControlName="{{form_elem.fieldid}}" [myLabel]="form_elem.label" [id]="form_elem.fieldid"
                          [optionCollection]="form_elem.items" [optionViewProperty]="opt" [optionValueProperty]="opt"
                          [required]="form_elem.required" [optional]="form_elem.optional">
                        </app-dynamic-dropdown>

                        <app-dynamic-dropdown *ngIf="!isIE && !isDE" [myUser]="myUser"
                          [invalid]="submitted && myFormGroup.get(form_elem.fieldid).errors"
                          formControlName="{{form_elem.fieldid}}" [myLabel]="form_elem.label" [id]="form_elem.fieldid"
                          [optionCollection]="myCountries" [optionViewProperty]="opt" [optionValueProperty]="opt"
                          [required]="form_elem.required" [optional]="form_elem.optional">
                        </app-dynamic-dropdown>

                        <label class="ovale" *ngIf="isDE" for="{{form_elem.fieldid}}">{{form_elem.label}}</label>
                        <div *ngIf="isIE && isDE">
                          <div class="dynamic-form-data-entry-input">
                            <span class="required-field">{{form_elem.required}}</span>
                            <span class="optional-field">{{form_elem.optional}}</span>
                            <select class="form-control"
                              [ngClass]="{'is-invalid' :submitted && myFormGroup.get(form_elem.fieldid).errors}"
                              formControlName="{{form_elem.fieldid}}">
                              <option>Select Country</option>
                              <option *ngFor="let opt of myCountries" value="{{opt}}">
                                {{opt}}
                              </option>
                            </select>
                          </div>
                        </div>

                        <div *ngIf="!isIE && isDE">
                          <div class="dynamic-form-data-entry-input">
                            <span class="required-field">{{form_elem.required}}</span>
                            <span class="optional-field">{{form_elem.optional}}</span>
                            <select class="form-control"
                              [ngClass]="{'is-invalid' :submitted && myFormGroup.get(form_elem.fieldid).errors}"
                              formControlName="{{form_elem.fieldid}}">
                              <option *ngFor="let opt of myCountries" value="{{opt}}">
                                {{opt}}
                              </option>
                            </select>
                          </div>
                        </div>

                        <div *ngIf="submitted && myFormGroup.get(form_elem.fieldid).errors" class="invalid-feedback">
                          <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.required">This
                            is a
                            required
                            field.
                          </div>
                        </div>

                      </div>
                    </section>

                    <section *ngSwitchCase="'dropdownshow'" class="dropdownshow-dynamic">
                      <div *ngIf="dummyShowTrigger?showMe(form_elem.fieldid):showMe(form_elem.fieldid)">
                        <div class="dynamic-item form-group">

                          <div *ngIf="form_elem.explanation.length>0" class="dynamic-info-btn-freetext"
                            ngbTooltip="{{form_elem.explanation}}" placement="{{form_elem.tooltipPlacement}}">
                            <!-- <img src="../../assets/img/info-btn.svg" height="35px" alt=""> -->
                            <div class="svg-container help-btn-svg-container">
                              <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 832.46 905" width="30px">

                                <path
                                  d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                  transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                                <path
                                  d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                  transform="translate(-95.77 -59.5)" fill="#fff" />
                                <path
                                  d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                                <path
                                  d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                              </svg>
                            </div>
                          </div>
                          <!-- Tooltip on mobile -->
                          <div *ngIf="statusTooltipMobile[i] && form_elem.explanation.length>0"
                            class="container-tooltip-show-mobile">
                            <div class="tooltip-show-mobile">{{form_elem.explanation}}</div>
                          </div>
                          <div class="info-mark-mobile" *ngIf="questionMarkMobile && form_elem.explanation.length>0"
                            (click)="statusTooltipMobile[i] = !statusTooltipMobile[i]">
                            <!-- <img src="../../assets/img/info-btn.svg" height="35px"
                                                        alt="section logo" height="35px"> -->
                            <div class="svg-container help-btn-svg-container">
                              <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 832.46 905" width="30px">

                                <path
                                  d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                  transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                                <path
                                  d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                  transform="translate(-95.77 -59.5)" fill="#fff" />
                                <path
                                  d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                                <path
                                  d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                              </svg>
                            </div>
                          </div>

                          <app-dynamic-dropdown *ngIf="isIE && !isDE" [myUser]="myUser"
                            [invalid]="submitted && myFormGroup.get(form_elem.fieldid).errors"
                            formControlName="{{form_elem.fieldid}}" [myLabel]="form_elem.label" [id]="form_elem.fieldid"
                            [optionCollection]="form_elem.items" [optionViewProperty]="opt" [optionValueProperty]="opt"
                            [required]="form_elem.required" [optional]="form_elem.optional">
                          </app-dynamic-dropdown>

                          <app-dynamic-dropdown *ngIf="!isIE && !isDE" [myUser]="myUser"
                            [invalid]="submitted && myFormGroup.get(form_elem.fieldid).errors"
                            formControlName="{{form_elem.fieldid}}" [myLabel]="form_elem.label" [id]="form_elem.fieldid"
                            [optionCollection]="form_elem.items" [optionViewProperty]="opt" [optionValueProperty]="opt"
                            [required]="form_elem.required" [optional]="form_elem.optional">
                          </app-dynamic-dropdown>

                          <label class="ovale" *ngIf="isDE" for="{{form_elem.fieldid}}">{{form_elem.label}}</label>
                          <div *ngIf="isIE && isDE">
                            <div class="dynamic-form-data-entry-input">
                              <span class="required-field">{{form_elem.required}}</span>
                              <span class="optional-field">{{form_elem.optional}}</span>
                              <select class="form-control" formControlName="{{form_elem.fieldid}}"
                                [ngClass]="{'is-invalid' :submitted && myFormGroup.get(form_elem.fieldid).errors}">
                                <option>Select Option</option>
                                <option *ngFor="let opt of form_elem.items" value="{{opt}}">
                                  {{opt}}
                                </option>
                              </select>
                            </div>
                          </div>

                          <div *ngIf="!isIE && isDE">
                            <div class="dynamic-form-data-entry-input">
                              <span class="required-field">{{form_elem.required}}</span>
                              <span class="optional-field">{{form_elem.optional}}</span>
                              <select class="form-control" formControlName="{{form_elem.fieldid}}"
                                [ngClass]="{'is-invalid' :submitted && myFormGroup.get(form_elem.fieldid).errors}">

                                <option *ngFor="let opt of form_elem.items" value="{{opt}}">
                                  {{opt}}
                                </option>
                              </select>
                            </div>
                          </div>

                          <div *ngIf="submitted && myFormGroup.get(form_elem.fieldid).errors" class="invalid-feedback">
                            <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.required">
                              This is a
                              required
                              field.
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>

                    <section *ngSwitchCase="'dropdownshowmultiselect'" class="dropdownshowmultiselect-dynamic">
                      <div *ngIf="dummyShowTrigger?showMe(form_elem.fieldid):showMe(form_elem.fieldid)">
                        <div class="dynamic-item form-group">

                          <label for="{{form_elem.fieldid}}">{{form_elem.label}}</label>

                          <div *ngIf="isIE" ;>
                            <div class="dynamic-form-data-entry-input">
                              <span class="required-field">{{form_elem.required}}</span>
                              <span class="optional-field">{{form_elem.optional}}</span>
                              <select multiple class="form-control" formControlName="{{form_elem.fieldid}}"
                                [ngClass]="{'is-invalid' :submitted && myFormGroup.get(form_elem.fieldid).errors}">
                                <option>Select Option</option>
                                <option *ngFor="let opt of form_elem.items" value="{{opt}}"
                                  (change)="changeItem($event,form_elem.itemName)">
                                  {{opt}}
                                </option>
                              </select>
                            </div>
                          </div>

                          <div *ngIf="!isIE" ;>
                            <div class="dynamic-form-data-entry-input">
                              <span class="required-field">{{form_elem.required}}</span>
                              <span class="optional-field">{{form_elem.optional}}</span>
                              <select multiple class="form-control" formControlName="{{form_elem.fieldid}}"
                                [ngClass]="{'is-invalid' :submitted && myFormGroup.get(form_elem.fieldid).errors}">

                                <option *ngFor="let opt of form_elem.items" value="{{opt}}"
                                  (change)="changeItem($event,form_elem.itemName)">
                                  {{opt}}
                                </option>
                              </select>
                            </div>
                          </div>

                          <div *ngIf="submitted && myFormGroup.get(form_elem.fieldid).errors" class="invalid-feedback">
                            <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.required">
                              This is a
                              required
                              field.
                            </div>
                          </div>

                        </div>
                      </div>
                    </section>

                    <section *ngSwitchCase="'dropdownshowmultiselectid'" class="dropdownshowmultiselect-dynamic">
                      <div *ngIf="dummyShowTrigger?showMe(form_elem.fieldid):showMe(form_elem.fieldid)">
                        <div class="dynamic-item form-group">

                          <label for="{{form_elem.fieldid}}">{{form_elem.label}}</label>

                          <div class="dynamic-form-data-entry-input">
                            <span class="required-field">{{form_elem.required}}</span>
                            <span class="optional-field">{{form_elem.optional}}</span>
                            <select multiple class="form-control" formControlName="{{form_elem.fieldid}}"
                              [ngClass]="{'is-invalid' :submitted && myFormGroup.get(form_elem.fieldid).errors}">
                              <option *ngFor="let opt of form_elem.itemArray" value="{{opt.Id}}"
                                (change)="changeItem($event,form_elem.itemName)">
                                {{opt.itemName}}
                              </option>
                            </select>
                          </div>

                          <div *ngIf="submitted && myFormGroup.get(form_elem.fieldid).errors" class="invalid-feedback">
                            <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.required">
                              This is a
                              required
                              field.
                            </div>
                          </div>

                        </div>
                      </div>
                    </section>

                    <section *ngSwitchCase="'multicheckbox'" class="multicheckbox-dynamic">
                      <div class="form-group dynamic-item"
                        *ngIf="dummyShowTrigger?showMe(form_elem.fieldid):showMe(form_elem.fieldid)">
                        <label class="label-multi-checkbox" for="{{form_elem.fieldid}}">{{form_elem.label}}
                          <div *ngIf="form_elem.explanation.length>0" class="dynamic-info-btn-multicheckbox"
                            ngbTooltip="{{form_elem.explanation}}" placement="{{form_elem.tooltipPlacement}}">
                            <!-- <img src="../../assets/img/info-btn.svg" height="35px" alt=""> -->
                            <div class="svg-container help-btn-svg-container">
                              <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 832.46 905" width="30px">

                                <path
                                  d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                  transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                                <path
                                  d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                  transform="translate(-95.77 -59.5)" fill="#fff" />
                                <path
                                  d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                                <path
                                  d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                              </svg>
                            </div>
                          </div>
                          <!-- Tooltip on mobile -->
                          <div *ngIf="statusTooltipMobile[i] && form_elem.explanation.length>0"
                            class="container-tooltip-show-mobile">
                            <div class="tooltip-show-mobile">{{form_elem.explanation}}</div>
                          </div>
                          <div class="info-mark-mobile" *ngIf="questionMarkMobile && form_elem.explanation.length>0"
                            (click)="statusTooltipMobile[i] = !statusTooltipMobile[i]">
                            <!-- <img src="../../assets/img/info-btn.svg" height="35px"
                                                        alt="section logo" height="35px"> -->
                            <div class="svg-container help-btn-svg-container">
                              <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 832.46 905" width="30px">

                                <path
                                  d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                  transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                                <path
                                  d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                  transform="translate(-95.77 -59.5)" fill="#fff" />
                                <path
                                  d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                                <path
                                  d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                              </svg>
                            </div>
                          </div>
                        </label>

                        <app-multi-checkbox [parentForm]="myFormGroup" [fieldId]="form_elem.fieldid"
                          [listSource]="form_elem.listSource" [label]="form_elem.label"
                          [arrayOptions]="form_elem.options" [myUser]="myUser">
                        </app-multi-checkbox>
                      </div>
                    </section>

                    <section *ngSwitchCase="'conditionaldropdown'" class="conditionaldropdown-dynamic"
                      [ngClass]="{data50percents: form_elem.delegateIntro == 'true'}">
                      <ng-container *ngIf="dummyShowTrigger?showMe(form_elem.fieldid):showMe(form_elem.fieldid)">
                        <div class="dynamic-item form-group">

                          <app-dynamic-dropdown *ngIf="isIE && !isDE" [myUser]="myUser"
                            [invalid]="submitted && myFormGroup.get(form_elem.fieldid).errors"
                            formControlName="{{form_elem.fieldid}}" [myLabel]="form_elem.label" [id]="form_elem.fieldid"
                            [optionCollection]="form_elem.items" [optionViewProperty]="opt" [optionValueProperty]="opt"
                            [required]="form_elem.required" [optional]="form_elem.optional">
                          </app-dynamic-dropdown>

                          <app-dynamic-dropdown *ngIf="!isIE && !isDE" [myUser]="myUser"
                            [invalid]="submitted && myFormGroup.get(form_elem.fieldid).errors"
                            formControlName="{{form_elem.fieldid}}" [myLabel]="form_elem.label" [id]="form_elem.fieldid"
                            [optionCollection]="form_elem.urlparameters" [optionViewProperty]="'option'"
                            [optionValueProperty]="'option'" [required]="form_elem.required"
                            [optional]="form_elem.optional" (change)="changeSelection($event,form_elem.urlparameters)">
                          </app-dynamic-dropdown>

                          <label class="ovale" *ngIf="isDE" for="{{form_elem.fieldid}}">{{form_elem.label}}</label>

                          <div *ngIf="isIE && isDE">
                            <div class="dynamic-form-data-entry-input">
                              <span class="required-field">{{form_elem.required}}</span>
                              <span class="optional-field">{{form_elem.optional}}</span>
                              <select class="form-control" formControlName="{{form_elem.fieldid}}"
                                (change)="changeSelection($event,form_elem.urlparameters)"
                                [ngClass]="{'is-invalid' :submitted && myFormGroup.get(form_elem.fieldid).errors}">
                                <option class="dynamic-edit-option" *ngFor="let item of form_elem.urlparameters"
                                  value="{{item.option}}"
                                  [ngClass]="{'capitalize-option': item.option == 'contributor' || item.option == 'now' || item.option == 'future' || item.option == 'never'}">
                                  {{item.option}}
                                </option>
                              </select>
                            </div>
                          </div>

                          <div *ngIf="!isIE && isDE">
                            <div class="dynamic-form-data-entry-input">
                              <span class="required-field">{{form_elem.required}}</span>
                              <span class="optional-field">{{form_elem.optional}}</span>
                              <select class="form-control select-capitalize" formControlName="{{form_elem.fieldid}}"
                                (focus)="onSelectFocus($event)"
                                (change)="changeSelection($event,form_elem.urlparameters)"
                                [ngClass]="{'is-invalid' :submitted && myFormGroup.get(form_elem.fieldid).errors}">
                                <option class="dynamic-edit-option" *ngFor="let item of form_elem.urlparameters"
                                  value="{{item.option}}" [ngClass]="{'capitalize-option': item.option == 'contributor' ||
                                              item.option == 'now' ||
                                              item.option == 'future' ||
                                              item.option == 'never'}" [ngSwitch]="item.option">
                                  <ng-container *ngSwitchCase="'now'">viewer now</ng-container>
                                  <ng-container *ngSwitchCase="'future'">viewer future</ng-container>
                                  <ng-container *ngSwitchDefault>{{item.option}}</ng-container>
                                </option>
                              </select>
                            </div>
                          </div>

                          <div *ngIf="submitted && myFormGroup.get(form_elem.fieldid).errors" class="invalid-feedback">
                            <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.required">
                              This is a required field.
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </section>

                    <section *ngSwitchCase="'conditionaldropdownshow'" class="conditionaldropdownshow-dynamic">
                      <div *ngIf="dummyShowTrigger?showMe(form_elem.fieldid):showMe(form_elem.fieldid)">
                        <div class="dynamic-item form-group">

                          <div *ngIf="form_elem.explanation.length>0" class="dynamic-info-btn-freetext"
                            ngbTooltip="{{form_elem.explanation}}" placement="{{form_elem.tooltipPlacement}}">
                            <!-- <img src="../../assets/img/info-btn.svg" height="35px" alt=""> -->
                            <div class="svg-container help-btn-svg-container">
                              <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 832.46 905" width="30px">

                                <path
                                  d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                  transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                                <path
                                  d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                  transform="translate(-95.77 -59.5)" fill="#fff" />
                                <path
                                  d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                                <path
                                  d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                              </svg>
                            </div>
                          </div>
                          <!-- Tooltip on mobile -->
                          <div *ngIf="statusTooltipMobile[i] && form_elem.explanation.length>0"
                            class="container-tooltip-show-mobile">
                            <div class="tooltip-show-mobile">{{form_elem.explanation}}</div>
                          </div>
                          <div class="info-mark-mobile" *ngIf="questionMarkMobile && form_elem.explanation.length>0"
                            (click)="statusTooltipMobile[i] = !statusTooltipMobile[i]">
                            <!-- <img src="../../assets/img/info-btn.svg" height="35px"
                                                        alt="section logo" height="35px"> -->
                            <div class="svg-container help-btn-svg-container">
                              <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 832.46 905" width="30px">

                                <path
                                  d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                  transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                                <path
                                  d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                  transform="translate(-95.77 -59.5)" fill="#fff" />
                                <path
                                  d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                                <path
                                  d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                              </svg>
                            </div>
                          </div>

                          <label class="ovale" for="{{form_elem.fieldid}}">{{form_elem.label}}</label>

                          <div *ngIf="isIE">
                            <div class="dynamic-form-data-entry-input">
                              <span class="required-field">{{form_elem.required}}</span>
                              <span class="optional-field">{{form_elem.optional}}</span>
                              <select formControlName="{{form_elem.fieldid}}"
                                (change)="changeSelection($event,form_elem.urlparameters)"
                                [ngClass]="{'is-invalid' :submitted && myFormGroup.get(form_elem.fieldid).errors}">
                                <option>Select Option</option>
                                <option *ngFor="let item of form_elem.urlparameters" value="{{item.option}}">
                                  {{item.option}}
                                </option>
                              </select>
                            </div>
                          </div>

                          <div *ngIf="!isIE">
                            <div class="dynamic-form-data-entry-input">
                              <span class="required-field">{{form_elem.required}}</span>
                              <span class="optional-field">{{form_elem.optional}}</span>
                              <select formControlName="{{form_elem.fieldid}}"
                                (change)="changeSelection($event,form_elem.urlparameters)"
                                [ngClass]="{'is-invalid' :submitted && myFormGroup.get(form_elem.fieldid).errors}">

                                <option *ngFor="let item of form_elem.urlparameters" value="{{item.option}}">
                                  {{item.option}}
                                </option>
                              </select>
                            </div>
                          </div>

                          <div *ngIf="submitted && myFormGroup.get(form_elem.fieldid).errors" class="invalid-feedback">
                            <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.required">
                              This is a required field.
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>

                    

                    <section *ngSwitchCase="'yesnotoggleconditional'" class="yesnotoggle-dynamic">
                      <div class="dynamic-item form-group">
                        <div *ngIf="form_elem.explanation.length>0" class="dynamic-info-btn-yesnotoggle"
                          ngbTooltip="{{form_elem.explanation}}" placement="{{form_elem.tooltipPlacement}}">
                          <!-- <img src="../../assets/img/info-btn.svg" height="35px" alt=""> -->
                          <div class="svg-container help-btn-svg-container">
                            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 832.46 905" width="30px">

                              <path
                                d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                              <path
                                d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                transform="translate(-95.77 -59.5)" fill="#fff" />
                              <path
                                d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                transform="translate(-95.77 -59.5)" class="svg-sign" />
                              <path
                                d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                transform="translate(-95.77 -59.5)" class="svg-sign" />
                            </svg>
                          </div>
                        </div>
                        <!-- Tooltip on mobile -->
                        <div *ngIf="statusTooltipMobile[i] && form_elem.explanation.length>0"
                          class="container-tooltip-show-mobile">
                          <div class="tooltip-show-mobile">{{form_elem.explanation}}</div>
                        </div>
                        <div class="info-mark-mobile" *ngIf="questionMarkMobile && form_elem.explanation.length>0"
                          (click)="statusTooltipMobile[i] = !statusTooltipMobile[i]">
                          <!-- <img src="../../assets/img/info-btn.svg" height="35px"
                                                    alt="section logo" height="35px"> -->
                          <div class="svg-container help-btn-svg-container">
                            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 832.46 905" width="30px">

                              <path
                                d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                              <path
                                d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                transform="translate(-95.77 -59.5)" fill="#fff" />
                              <path
                                d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                transform="translate(-95.77 -59.5)" class="svg-sign" />
                              <path
                                d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                transform="translate(-95.77 -59.5)" class="svg-sign" />
                            </svg>
                          </div>
                        </div>

                        <label>{{form_elem.label}}</label>
                        <label *ngIf="form_elem.scdLabel">{{form_elem.scdLabel}}</label>

                        <div class="custom-control custom-switch">

                          <div class="checkbox">
                            <input type="checkbox" checked="checked" class="mytoggle"
                              formControlName="{{form_elem.fieldid}}" id="{{'customSwitches_'+form_elem.fieldid}}"
                              (click)="forkClickYesNo(form_elem.fieldid,form_elem.urlparameters)">
                            <label for="{{'customSwitches_'+form_elem.fieldid}}"
                              id="{{'lbl_'+form_elem.fieldid}}"></label>
                          </div>

                          <div class="custom-switch-answer" *ngIf="myFormGroup.get(form_elem.fieldid).value"
                            style="display: inline-block;">
                            Yes
                          </div>

                          <div class="custom-switch-answer" *ngIf="!myFormGroup.get(form_elem.fieldid).value"
                            style="display: inline-block;">
                            No
                          </div>
                        </div>
                        <div *ngIf="myFormTemplate.consentUser == true && !myFormGroup.get(form_elem.fieldid).value"
                          class="invalid-feedback">
                          You must consent to continue.
                        </div>
                        <div
                          *ngIf="form_elem.securedPasswordConsent == true && !myFormGroup.get(form_elem.fieldid).value"
                          class="invalid-feedback">
                          It is important to secure your master password in a safe place.
                        </div>
                        <div
                          *ngIf="form_elem.passwordRecoveryConsent == true && !myFormGroup.get(form_elem.fieldid).value"
                          class="invalid-feedback">
                          Providers often offer several account recovery methods to restore access if your master
                          password is ever lost or forgotten.
                        </div>
                      </div>
                      <!-- </div> -->
                    </section>

                    <section *ngSwitchCase="'yesnotogglehideshow'" class="yesnotoggle-dynamic">
                      <div *ngIf="dummyShowTrigger?showMe(form_elem.fieldid):showMe(form_elem.fieldid)">
                        <div class="dynamic-item form-group">
                          <div *ngIf="form_elem.explanation.length>0" class="dynamic-info-btn-yesnotoggle"
                            ngbTooltip="{{form_elem.explanation}}" placement="{{form_elem.tooltipPlacement}}">
                            <!-- <img src="../../assets/img/info-btn.svg" height="35px" alt=""> -->
                            <div class="svg-container help-btn-svg-container">
                              <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 832.46 905" width="30px">

                                <path
                                  d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                  transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                                <path
                                  d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                  transform="translate(-95.77 -59.5)" fill="#fff" />
                                <path
                                  d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                                <path
                                  d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                              </svg>
                            </div>
                          </div>
                          <!-- Tooltip on mobile -->
                          <div *ngIf="statusTooltipMobile[i] && form_elem.explanation.length>0"
                            class="container-tooltip-show-mobile">
                            <div class="tooltip-show-mobile">{{form_elem.explanation}}</div>
                          </div>
                          <div class="info-mark-mobile" *ngIf="questionMarkMobile && form_elem.explanation.length>0"
                            (click)="statusTooltipMobile[i] = !statusTooltipMobile[i]">
                            <!-- <img src="../../assets/img/info-btn.svg" height="35px"
                                                        alt="section logo" height="35px"> -->
                            <div class="svg-container help-btn-svg-container">
                              <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 832.46 905" width="30px">

                                <path
                                  d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                  transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                                <path
                                  d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                  transform="translate(-95.77 -59.5)" fill="#fff" />
                                <path
                                  d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                                <path
                                  d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                              </svg>
                            </div>
                          </div>

                          <label>{{form_elem.label}}</label>

                          <div class="custom-control custom-switch">
                            <div class="checkbox">
                              <input type="checkbox" checked="checked" class="mytoggle"
                                formControlName="{{form_elem.fieldid}}" id="{{'customSwitches_'+form_elem.fieldid}}"
                                (click)="forkClickYesNoHideShow(form_elem.fieldid,form_elem.urlparameters,false,false)">
                              <label for="{{'customSwitches_'+form_elem.fieldid}}"
                                id="{{'lbl_'+form_elem.fieldid}}"></label>
                              <!-- [ngClass]="{removeToggle: removeToggle == true}" -->
                            </div>

                            <div class="custom-switch-answer" *ngIf="myFormGroup.get(form_elem.fieldid).value"
                              style="display: inline-block;">
                              Yes
                            </div>

                            <div class="custom-switch-answer" *ngIf="!myFormGroup.get(form_elem.fieldid).value"
                              style="display: inline-block;">
                              No
                            </div>

                          </div>

                        </div>

                      </div>
                    </section>

                    <section *ngSwitchCase="'radiobuttonsdata'" class="radiobuttonsdata-dynamic">
                      <div class="dynamic-item form-group">

                        <div *ngIf="form_elem.explanation.length>0" class="dynamic-info-btn-freetext"
                          ngbTooltip="{{form_elem.explanation}}" placement="{{form_elem.tooltipPlacement}}">
                          <!-- <img src="../../assets/img/info-btn.svg" height="35px" alt=""> -->
                          <div class="svg-container help-btn-svg-container">
                            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 832.46 905" width="30px">

                              <path
                                d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                              <path
                                d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                transform="translate(-95.77 -59.5)" fill="#fff" />
                              <path
                                d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                transform="translate(-95.77 -59.5)" class="svg-sign" />
                              <path
                                d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                transform="translate(-95.77 -59.5)" class="svg-sign" />
                            </svg>
                          </div>
                        </div>
                        <!-- Tooltip on mobile -->
                        <div *ngIf="statusTooltipMobile[i] && form_elem.explanation.length>0"
                          class="container-tooltip-show-mobile">
                          <div class="tooltip-show-mobile">{{form_elem.explanation}}</div>
                        </div>
                        <div class="info-mark-mobile" *ngIf="questionMarkMobile && form_elem.explanation.length>0"
                          (click)="statusTooltipMobile[i] = !statusTooltipMobile[i]">
                          <!-- <img src="../../assets/img/info-btn.svg" height="35px"
                                                    alt="section logo" height="35px"> -->
                          <div class="svg-container help-btn-svg-container">
                            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 832.46 905" width="30px">

                              <path
                                d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                              <path
                                d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                transform="translate(-95.77 -59.5)" fill="#fff" />
                              <path
                                d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                transform="translate(-95.77 -59.5)" class="svg-sign" />
                              <path
                                d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                transform="translate(-95.77 -59.5)" class="svg-sign" />
                            </svg>
                          </div>
                        </div>

                        <label *ngIf="form_elem.label">{{form_elem.label}}</label>

                        <div *ngIf="form_elem.options[0]=='Yes'; else elseBlock">
                          <div class="custom-control custom-switch">
                            <div class="checkbox">
                              <input type="checkbox" checked="checked" class="mytoggle"
                                formControlName="{{form_elem.fieldid}}" id="{{'customSwitches_'+form_elem.fieldid}}">
                              <label for="{{'customSwitches_'+form_elem.fieldid}}"
                                id="{{'lbl_'+form_elem.fieldid}}"></label>
                            </div>

                            <div class="custom-switch-answer" *ngIf="myFormGroup.get(form_elem.fieldid).value"
                              style="display: inline-block;">
                              Yes
                            </div>

                            <div class="custom-switch-answer" *ngIf="!myFormGroup.get(form_elem.fieldid).value"
                              style="display: inline-block;">
                              No
                            </div>
                          </div>
                        </div>
                        <ng-template #elseBlock>
                          <div *ngFor="let option of form_elem.options">
                            <label class="check-label">
                              {{option}}
                              <input type="radio" formControlName="{{form_elem.fieldid}}" value="{{option}}"
                                class="form-check-input" />
                              <span class="radio-label checkmark"></span> <br>
                            </label>
                          </div>
                        </ng-template>
                        <!-- <div *ngIf="generalExpenseFieldNoEmpty?true:false">
                                                <div class="invalid-feedback">This is a required field.</div>
                                            </div> -->
                        <div *ngIf="submitted && myFormGroup.get(form_elem.fieldid).errors">
                          <div class="invalid-feedback">This is a required field.</div>
                        </div>
                      </div>
                    </section>

                    <section *ngSwitchCase="'yesnotoggle'" class="yesnotoggle-dynamic">
                      <div class="dynamic-item form-group">

                        <div *ngIf="form_elem.explanation.length>0" class="dynamic-info-btn-yesnotoggle"
                          ngbTooltip="{{form_elem.explanation}}" placement="{{form_elem.tooltipPlacement}}">
                          <!-- <img src="../../assets/img/info-btn.svg" height="35px" alt=""> -->
                          <div class="svg-container help-btn-svg-container">
                            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 832.46 905" width="30px">

                              <path
                                d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                              <path
                                d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                transform="translate(-95.77 -59.5)" fill="#fff" />
                              <path
                                d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                transform="translate(-95.77 -59.5)" class="svg-sign" />
                              <path
                                d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                transform="translate(-95.77 -59.5)" class="svg-sign" />
                            </svg>
                          </div>
                        </div>
                        <!-- Tooltip on mobile -->
                        <div *ngIf="statusTooltipMobile[i] && form_elem.explanation.length>0"
                          class="container-tooltip-show-mobile">
                          <div class="tooltip-show-mobile">{{form_elem.explanation}}</div>
                        </div>
                        <div class="info-mark-mobile" *ngIf="questionMarkMobile && form_elem.explanation.length>0"
                          (click)="statusTooltipMobile[i] = !statusTooltipMobile[i]">
                          <!-- <img src="../../assets/img/info-btn.svg" height="35px"
                                                    alt="section logo" height="35px"> -->
                          <div class="svg-container help-btn-svg-container">
                            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 832.46 905" width="30px">

                              <path
                                d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                              <path
                                d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                transform="translate(-95.77 -59.5)" fill="#fff" />
                              <path
                                d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                transform="translate(-95.77 -59.5)" class="svg-sign" />
                              <path
                                d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                transform="translate(-95.77 -59.5)" class="svg-sign" />
                            </svg>
                          </div>
                        </div>

                        <label>{{form_elem.label}}</label>
                        <div class="custom-checkbox-switch-container">

                          <div class="checkbox">
                            <input type="checkbox" checked="checked" class="mytoggle"
                              formControlName="{{form_elem.fieldid}}" id="{{'customSwitches_'+form_elem.fieldid}}">
                            <label for="{{'customSwitches_'+form_elem.fieldid}}"
                              id="{{'customSwitches_'+form_elem.fieldid}}"></label>
                          </div>

                          <div class="custom-checkbox-switch-answer">
                            <div *ngIf="myFormGroup.get(form_elem.fieldid).value" style="display: inline-block;">
                              Yes
                            </div>
                            <div *ngIf="!myFormGroup.get(form_elem.fieldid).value" style="display: inline-block;">
                              No
                            </div>
                          </div>
                        </div>

                        <div *ngIf="submitted && myFormGroup.get(form_elem.fieldid).errors">
                          <div *ngIf="form_elem.mandatory">This is a required field.</div>
                        </div>
                      </div>
                    </section>

                    <section *ngSwitchCase="'specialyesnotoggle'" class="yesnotoggle-dynamic">
                      <div class="dynamic-item form-group">
                        <div *ngIf="form_elem.explanation.length>0" class="dynamic-info-btn-yesnotoggle"
                          ngbTooltip="{{form_elem.explanation}}" placement="{{form_elem.tooltipPlacement}}">
                          <!-- <img src="../../assets/img/info-btn.svg" width="35px" alt=""> -->
                          <div class="svg-container help-btn-svg-container">
                            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 832.46 905" width="30px">

                              <path
                                d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                              <path
                                d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                transform="translate(-95.77 -59.5)" fill="#fff" />
                              <path
                                d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                transform="translate(-95.77 -59.5)" class="svg-sign" />
                              <path
                                d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                transform="translate(-95.77 -59.5)" class="svg-sign" />
                            </svg>
                          </div>
                        </div>
                        <!-- Tooltip on mobile -->
                        <div *ngIf="statusTooltipMobile[i] && form_elem.explanation.length>0"
                          class="container-tooltip-show-mobile">
                          <div class="tooltip-show-mobile">{{form_elem.explanation}}</div>
                        </div>
                        <div class="info-mark-mobile" *ngIf="questionMarkMobile && form_elem.explanation.length>0"
                          (click)="statusTooltipMobile[i] = !statusTooltipMobile[i]">
                          <!-- <img src="../../assets/img/info-btn.svg" width="35px" alt="section logo"
                                                    width="35px"> -->
                          <div class="svg-container help-btn-svg-container">
                            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 832.46 905" width="30px">

                              <path
                                d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                              <path
                                d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                transform="translate(-95.77 -59.5)" fill="#fff" />
                              <path
                                d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                transform="translate(-95.77 -59.5)" class="svg-sign" />
                              <path
                                d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                transform="translate(-95.77 -59.5)" class="svg-sign" />
                            </svg>
                          </div>
                        </div>

                        <label *ngIf="form_elem.label">{{form_elem.label}}</label>
                        <div class="special-custom-checkbox-switch-container">

                          <div class="checkbox">
                            <input type="checkbox" checked="checked" class="mytoggle"
                              formControlName="{{form_elem.fieldid}}" id="{{'customSwitches_'+form_elem.fieldid}}">
                            <label for="{{'customSwitches_'+form_elem.fieldid}}"
                              id="{{'customSwitches_'+form_elem.fieldid}}"></label>
                            <span>{{form_elem.text}}</span>
                          </div>
                        </div>

                        <div *ngIf="submitted && myFormGroup.get(form_elem.fieldid).errors">
                          <div *ngIf="form_elem.mandatory">This is a required field.</div>
                        </div>
                      </div>
                    </section>

                    <section *ngSwitchCase="'radiobuttonsdatashow'" class="radiobuttonsdatashow-dynamic">
                      <div class="dynamic-item form-group">
                        <div *ngIf="dummyShowTrigger?showMe(form_elem.fieldid):showMe(form_elem.fieldid)">
                          <div *ngIf="form_elem.explanation.length>0" class="dynamic-info-btn-freetext"
                            ngbTooltip="{{form_elem.explanation}}" placement="{{form_elem.tooltipPlacement}}">
                            <!-- <img src="../../assets/img/info-btn.svg" height="35px" alt=""> -->
                            <div class="svg-container help-btn-svg-container">
                              <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 832.46 905" width="30px">

                                <path
                                  d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                  transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                                <path
                                  d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                  transform="translate(-95.77 -59.5)" fill="#fff" />
                                <path
                                  d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                                <path
                                  d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                              </svg>
                            </div>
                          </div>
                          <!-- Tooltip on mobile -->
                          <div *ngIf="statusTooltipMobile[i] && form_elem.explanation.length>0"
                            class="container-tooltip-show-mobile">
                            <div class="tooltip-show-mobile">{{form_elem.explanation}}</div>
                          </div>
                          <div class="info-mark-mobile" *ngIf="questionMarkMobile && form_elem.explanation.length>0"
                            (click)="statusTooltipMobile[i] = !statusTooltipMobile[i]">
                            <!-- <img src="../../assets/img/info-btn.svg" height="35px"
                                                        alt="section logo" height="35px"> -->
                            <div class="svg-container help-btn-svg-container">
                              <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 832.46 905" width="30px">

                                <path
                                  d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                  transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                                <path
                                  d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                  transform="translate(-95.77 -59.5)" fill="#fff" />
                                <path
                                  d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                                <path
                                  d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                              </svg>
                            </div>
                          </div>

                          <label *ngIf="form_elem.label">{{form_elem.label}}</label>
                          <div *ngFor="let option of form_elem.options">
                            <label class="check-label">
                              {{option}}
                              <input type="radio" formControlName="{{form_elem.fieldid}}" value="{{option}}"
                                class="form-check-input" />
                              <span class="radio-label checkmark"></span> <br>
                            </label>
                          </div>

                          <div *ngIf="submitted && myFormGroup.get(form_elem.fieldid).errors" class="invalid-feedback">
                            <div *ngIf="form_elem.mandatory">This is a required field.</div>
                          </div>

                        </div>
                      </div>
                    </section>

                    <section *ngSwitchCase="'radiobuttonsshow'">
                      <div *ngIf="dummyShowTrigger?showMe(form_elem.fieldid):showMe(form_elem.fieldid)">
                        <div class="dynamic-item form-group">
                          <div *ngIf="form_elem.explanation.length>0" class="dynamic-info-btn-freetext"
                            ngbTooltip="{{form_elem.explanation}}" placement="{{form_elem.tooltipPlacement}}">
                            <!-- <img src="../../assets/img/info-btn.svg" height="35px" alt=""> -->
                            <div class="svg-container help-btn-svg-container">
                              <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 832.46 905" width="30px">

                                <path
                                  d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                  transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                                <path
                                  d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                  transform="translate(-95.77 -59.5)" fill="#fff" />
                                <path
                                  d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                                <path
                                  d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                              </svg>
                            </div>
                          </div>
                          <!-- Tooltip on mobile -->
                          <div *ngIf="statusTooltipMobile[i] && form_elem.explanation.length>0"
                            class="container-tooltip-show-mobile">
                            <div class="tooltip-show-mobile">{{form_elem.explanation}}</div>
                          </div>
                          <div class="info-mark-mobile" *ngIf="questionMarkMobile && form_elem.explanation.length>0"
                            (click)="statusTooltipMobile[i] = !statusTooltipMobile[i]">
                            <!-- <img src="../../assets/img/info-btn.svg" height="35px"
                                                        alt="section logo" height="35px"> -->
                            <div class="svg-container help-btn-svg-container">
                              <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 832.46 905" width="30px">

                                <path
                                  d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                  transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                                <path
                                  d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                  transform="translate(-95.77 -59.5)" fill="#fff" />
                                <path
                                  d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                                <path
                                  d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                  transform="translate(-95.77 -59.5)" class="svg-sign" />
                              </svg>
                            </div>
                          </div>
                          <label>{{form_elem.label}} <span class="required-field">{{form_elem.required}}</span></label>
                          <div *ngFor="let optionObject of form_elem.options">
                            <label class="check-label">
                              {{optionObject.option}}
                              <input type="radio" formControlName="{{form_elem.fieldid}}"
                                value="{{optionObject.option}}"
                                (click)="manageHideFields(optionObject.action,form_elem.showFields)"
                                class="form-check-input" />
                              <span class="radio-label checkmark"
                                [ngClass]="{removeCheckmark: removeCheckmark == true}"></span>
                              <br>
                            </label>
                          </div>
                          <div *ngIf="submitted && myFormGroup.get(form_elem.fieldid).errors" class="invalid-feedback">
                            <div>This is a required field.</div>
                          </div>
                        </div>
                      </div>
                    </section>

                    <div *ngSwitchCase="'blank'" style="flex-shrink:0"></div>

                    <section *ngSwitchCase="'datepicker'" class="datepicker-dynamic">
                      <div class="dynamic-item">
                        <div class="form-group">
                          <div *ngIf="dummyShowTrigger?showMe(form_elem.fieldid):showMe(form_elem.fieldid)">
                            <div *ngIf="form_elem.explanation.length>0" class="dynamic-info-btn-freetext info-mark-de"
                              ngbTooltip="{{form_elem.explanation}}" placement="{{form_elem.tooltipPlacement}}">
                              <!-- <img src="../../assets/img/info-btn.svg" height="35px" alt=""> -->
                              <div class="svg-container help-btn-svg-container">
                                <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 832.46 905" width="30px">

                                  <path
                                    d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                    transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                                  <path
                                    d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                    transform="translate(-95.77 -59.5)" fill="#fff" />
                                  <path
                                    d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                    transform="translate(-95.77 -59.5)" class="svg-sign" />
                                  <path
                                    d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                    transform="translate(-95.77 -59.5)" class="svg-sign" />
                                </svg>
                              </div>
                            </div>
                            <!-- Tooltip on mobile -->
                            <div *ngIf="statusTooltipMobile[i] && form_elem.explanation.length>0"
                              class="container-tooltip-show-mobile">
                              <div class="tooltip-show-mobile">{{form_elem.explanation}}</div>
                            </div>
                            <div class="info-mark-mobile" *ngIf="questionMarkMobile && form_elem.explanation.length>0"
                              (click)="statusTooltipMobile[i] = !statusTooltipMobile[i]">
                              <!-- <img src="../../assets/img/info-btn.svg" height="35px"
                                                        alt="section logo" height="35px"> -->
                              <div class="svg-container help-btn-svg-container">
                                <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 832.46 905" width="30px">

                                  <path
                                    d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                    transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                                  <path
                                    d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                    transform="translate(-95.77 -59.5)" fill="#fff" />
                                  <path
                                    d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                    transform="translate(-95.77 -59.5)" class="svg-sign" />
                                  <path
                                    d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                    transform="translate(-95.77 -59.5)" class="svg-sign" />
                                </svg>
                              </div>
                            </div>

                            <app-dynamic-input *ngIf="!isDE || myFormTemplate.aboutMe == true"
                              formControlName="{{form_elem.fieldid}}" [id]="form_elem.fieldid"
                              [invalid]="submitted && myFormGroup.get(form_elem.fieldid).errors"
                              (focusout)="form_elem.mustMatch ? MatchConfirmed($event,form_elem.mustMatch):null"
                              [myLabel]="form_elem.label" [type]="'date'" [required]="form_elem.required"
                              [optional]="form_elem.optional">
                            </app-dynamic-input>

                            <label class="ovale"
                              *ngIf="isDE && !myFormTemplate.aboutMe == true">{{form_elem.label}}</label>
                            <div *ngIf="isDE && !myFormTemplate.aboutMe == true" class="dynamic-form-data-entry-input">
                              <span class="required-field">{{form_elem.required}}</span>
                              <span class="optional-field">{{form_elem.optional}}</span>
                              <input type="date" class="form-control" formControlName="{{form_elem.fieldid}}"
                                min="1890-01-01" max="2050-12-31"
                                [ngClass]="{'is-invalid' :submitted && myFormGroup.get(form_elem.fieldid).errors, 'marginTopFieldMediaScreen': form_elem.marginTop == 'true'}">
                            </div>

                            <div *ngIf="submitted && myFormGroup.get(form_elem.fieldid).errors"
                              class="invalid-feedback">
                              <div *ngIf="myFormGroup.get(form_elem.fieldid).errors.required">
                                This is a
                                required
                                field.
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>

                    <section *ngSwitchCase="'specialCategoryData'" class="special-category-data-dynamic">
                      <section class="dynamic-item dynamic-special-section form-group">
                        <header>
                          <div class="special-title">{{form_elem.titleSpecialInfo}}</div>
                          <img src="../../assets/img/Padlock.png" alt="" width="90px">
                        </header>
                        <section class="special-content">
                          <div class="special-info">{{form_elem.specialInfo}}</div>
                        </section>
                      </section>
                    </section>

                  </section>
                  <section [ngSwitch]="form_elem.fieldid">
                    <div *ngSwitchCase="'upload'">
                      <app-file-upload [itemId]="Id || newItemId" [view]="false">
                      </app-file-upload>
                    </div>
                  </section>
                </section>

                <!-- Confirmation Modal -->
                <div *ngIf="showConfirmationModal" class="modal">
                  <div class="modal-content">
                    <p>Are you sure that you want to grant this delegate contributor access to your entire plan?</p>
                    <div>
                      <input class="btn btn-primary primary-default-btn" value="Yes" (click)="confirmSave()">
                      <input class="btn btn-primary primary-default-btn" value="No" (click)="cancelSave()">
                    </div>
                  </div>
                </div>

                <div class="no-items">


                  <!-- How Ownership Work -->
                  <div class="desktop-explanation dynamic-explanation"
                    [ngClass]="statusExplanations ? 'explanationDesktopCollapsed' : ''">
                    <div class="container">
                      <div class="closing-help-btn" (click)="statusExplanations = !statusExplanations">
                        <img alt="closing help button" src="../../assets/img/{{ themeService.theme }}/close-btn1.svg" />
                      </div>
                      <img src="../../assets/img/{{ themeService.theme }}/how-works.svg" alt="Section Logo"
                        width="150px" />
                      <div class="title">How ownership works</div>
                      <div>
                        When you add a financial item to your plan, you can allocate it to one or more owners.
                        There are three ownership options.
                      </div>
                      <div>
                        <div class="title">Sole owner</div>
                        <div>The item is wholly owned by one person e.g. you or your spouse. The full value of the item
                          is
                          assigned to the owner in the Financial Summaries.
                        </div>
                      </div>
                      <div>
                        <div class="title"> Joint tenant</div>
                        <div>The owners jointly own the whole item - this is common for married couples. The full value
                          of
                          the
                          item is assigned to both owners in the Financial Summaries.</div>
                      </div>
                      <div>
                        <div class="title">Tenants in common</div>
                        <div>The owners each own a specified share of the item. The specified share of the item is
                          assigned
                          to
                          each owner in the
                          Financial Summaries.</div>
                      </div>
                    </div>
                  </div>

                  <!-- How Delegate Work -->
                  <div class="desktop-explanation dynamic-explanation my-delegates-container delegate-explanation"
                    [ngClass]="statusExplanationsLink ? 'explanationDesktopCollapsed' : ''">
                    <app-delegate-explanation [addCloseBtn]="'addCloseBtn'"
                      (closeBtn)="closeExplanationAboutDelegates($event)"></app-delegate-explanation>
                  </div>

                  <!-- How Ownership Work Mobile -->
                  <div class="mobile-explanation dynamic-explanation"
                    [ngClass]="statusExplanations ? 'explanationMobileCollapsed' : ''">
                    <div class="container">
                      <div class="closing-help-btn" (click)="statusExplanations = !statusExplanations">
                        <img alt="closing help button" src="../../assets/img/{{ themeService.theme }}/close-btn1.svg" />
                      </div>
                      <img src="../../assets/img/{{ themeService.theme }}/how-works.svg" alt="Section Logo"
                        width="170px" />
                      <div class="title">How ownership works</div>
                      <p>
                        When you add a financial item to your plan, you can allocate it to one or more owners.
                        There are three ownership options.
                      </p>
                      <p>
                        <span class="title">Sole owner</span>
                        The item is wholly owned by one person e.g. you or your spouse. The full value of the item is
                        assigned to the owner in the Financial Summaries.
                      </p>
                      <p>
                        <span class="title"> Joint tenant</span>
                        The owners jointly own the whole item - this is common for married couples. The full value of
                        the
                        item is assigned to both owners in the Financial Summaries.
                      </p>
                      <p>
                        <span class="title">Tenants in common</span>
                        The owners each own a specified share of the item. The specified share of the item is assigned
                        to
                        each owner in the
                        Financial Summaries.
                      </p>
                    </div>
                  </div>
                </div>
              </section>
              <section class="next-step-btn"
                [ngClass]="{'next-step-btn-jointOwners': myFormTemplate && myFormTemplate.isJointOwners == true}">
                <input *ngIf="!myFormTemplate.introItem == true" class="btn btn-primary primary-sml-btn back-btn"
                  type="button" value="Back" (click)="backto()"
                  [ngClass]="{hideBackBtn: myFormTemplate.aboutMe == true}" />

                <input *ngIf="myFormTemplate.finishedbuttontext == 'Finished' && myFormTemplate.editMode != true"
                  class="btn btn-primary primary-default-btn next-btn 1" (click)="goto($event)" type="submit"
                  value="Finished" [disabled]="disabled" />

                <input *ngIf="myFormTemplate.finishedbuttontext == 'Finished' && myFormTemplate.editMode != true"
                  class="btn btn-primary primary-default-btn next-btn 2 new-item-btn" (click)="addNewItem()"
                  type="submit" value="Save and add another" [disabled]="disabled" />

                <!-- Standart Next button of the form -->
                <input
                  *ngIf="myFormTemplate.finishedbuttontext != 'Finished' && myFormTemplate.editMode != true && myFormTemplate.setPermission != 'true' && !myFormTemplate.isDelegate"
                  class="btn btn-primary primary-default-btn next-btn 3" (click)="goto()" type="submit" value="Next" />

                <!-- Button when Editing any item -->
                <input
                  *ngIf="myFormTemplate.editMode == true && myFormTemplate.aboutMe != true && myFormTemplate.editPermission != 'true'"
                  class="btn btn-primary primary-default-btn next-btn 4" (click)="goto()" type="submit"
                  value="Save Changes" />

                <!-- Button Save when Editing Delegate Permission -->
                <input *ngIf="myFormTemplate.editPermission == 'true'"
                  class="btn btn-primary primary-default-btn next-btn 5" (click)="handleSaveClick()" value="Save" />


                <input
                  *ngIf="(myFormTemplate.editMode == true && myFormTemplate.aboutMe == true) || myFormTemplate.setPermission == 'true'"
                  class="btn btn-primary primary-default-btn next-btn 6" (click)="goto()" type="submit"
                  value="Continue" />

                <input *ngIf="myFormTemplate.finishedbuttontext == 'send invite'"
                  class="btn btn-primary primary-default-btn next-btn 7" (click)="goto()" type="submit"
                  value="Send Invite" [disabled]="disabled" />
              </section>
            </form>
          </section>
        </section>
      </section>
    </section>
  </section>